// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/images/icon/icon_back.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/images/icon/icon_setting.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/assets/images/icon/icon_home.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/assets/images/icon/icon_menu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/assets/images/icon/icon_close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/assets/images/icon/icon_remove.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/src/assets/images/icon/icon_check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/src/assets/images/icon/icon_check_on.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/src/assets/images/icon/icon_filter.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/src/assets/images/icon/icon_search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/src/assets/images/icon/icon_round_naver.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/src/assets/images/icon/icon_round_kakao.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/src/assets/images/icon/icon_round_apple.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("/src/assets/images/icon/icon_agree.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("/src/assets/images/icon/icon_agree_on.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("/src/assets/images/icon/icon_agree_2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("/src/assets/images/icon/icon_agree_2_on.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("/src/assets/images/icon/icon_down_arr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("/src/assets/images/icon/icon_round_camera.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("/src/assets/images/icon/icon_alert.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("/src/assets/images/icon/icon_up_arr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("/src/assets/images/img/img_payment_card.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("/src/assets/images/icon/icon_warning.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("/src/assets/images/icon/icon_plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("/src/assets/images/bg/bg_receipt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("/src/assets/images/img/img_payment.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("/src/assets/images/img/img_banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("/src/assets/images/img/img_grade.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("/src/assets/images/img/img_clock.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("/src/assets/images/img/img_best.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("/src/assets/images/img/img_number2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("/src/assets/images/img/img_number3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("/src/assets/images/icon/icon_view.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("/src/assets/images/icon/icon_no_content.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("/src/assets/images/icon/icon_like.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("/src/assets/images/icon/icon_like_active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("/src/assets/images/icon/icon_comment.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("/src/assets/images/icon/icon_notice.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("/src/assets/images/icon/icon_plus_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("/src/assets/images/icon/icon_edit_btn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("/src/assets/images/icon/icon_comment2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("/src/assets/images/icon/icon_reply.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("/src/assets/images/icon/icon_camera.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("/src/assets/images/icon/icon_agree_on2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("/src/assets/images/icon/icon_w_back.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("/src/assets/images/icon/icon_cas_modal.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("/src/assets/images/icon/icon_calendar.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("/src/assets/images/bg/bg_splash.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("/src/assets/images/icon/icon_left_arr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("/src/assets/images/icon/icon_right_arr.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* layout */
.wrapper {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  min-height: 100vh;
}
.content {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 4rem);
  margin-top: 4rem;
  padding: 2rem;
  padding-bottom: 12rem;
  align-self: flex-end;
}

/* header */
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 4rem;
  padding: 0 2rem;
  background-color: #fff;
  z-index: 99;
}
header.right {
  justify-content: flex-end;
}
header h1 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 600;
  font-size: 1.6rem;
}
header .h-btn-box {
  display: flex;
  align-items: center;
  gap: 0.8em;
}
header .h-btn-box .back-btn {
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center /
    contain;
}
header .h-btn-box .setting-btn {
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center /
    contain;
}
header .h-btn-box .home-btn {
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center /
    contain;
}
header .h-btn-box .menu-btn {
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center /
    contain;
}
header .h-btn-box .close-btn {
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center /
    contain;
}

/* tab */
.find .tab {
  width: 100%;
  padding: 0.5rem;
  border-radius: 1.2rem;
  background-color: #f0f0f0;
}
.find .tab .tab-button {
  width: calc(100% / 2);
  height: 4rem;
  border-radius: 1.2rem;
  font-size: 1.4rem;
  color: #bbb;
}
.find .tab .tab-button.active {
  background-color: #fff;
  font-weight: 600;
  color: #000;
}

/* title-box */
/* .title-box h2 {
  font-weight: 500;
  font-size: 2rem;
  line-height: 1.35;
} */

/* button */
.fixed-button-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 2rem;
  background-color: #fff;
}
.fixed-button-box p,
.button-box p {
  font-size: 1.5rem;
  color: #333;
}
.fixed-button-box p button {
  position: relative;
  font-weight: 500;
  color: #000;
  text-decoration: underline;
}
.fixed-button-box p button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -0.8rem;
  width: 0.1rem;
  height: 100%;
  background-color: #444;
}
.button-box.type2 {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.btn1 {
  width: 100%;
  height: 5rem;
  border-radius: 1.2rem;
  font-weight: 600;
}
.button-box.type2 .btn1.narrow {
  width: calc(((100% - 1rem) / 5) * 2);
}
.button-box.type2 .btn1.wide {
  width: calc(((100% - 1rem) / 5) * 3);
}
.btn1.type2 {
  border-radius: 2.5rem;
}
.btn1.type3 {
  height: 4rem;
  border-radius: 2rem;
  font-weight: 500;
  font-size: 1.5rem;
}
.btn1.main-color {
  background-color: #00b1d8 !important;
  color: #fff !important;
}
.btn1.sub-color {
  background-color: #555 !important;
  color: #fff !important;
}
.btn1.disabled {
  background-color: #999 !important;
  color: #ccc !important;
}
.btn1.cancel {
  background-color: #ff7070 !important;
  color: #fff !important;
}

/* round-box */
.round-box {
  border-radius: 1.2rem;
  background-color: #f6f6f6;
}
.round-box.type2 {
  background-color: #f3fbff;
}
.round-box.type3 {
  background: linear-gradient(79deg, #1789fb 0.35%, #7fbcf8 98.51%);
}
.round-box.type4 {
  box-shadow: 0 0 0.25rem 0 rgba(153, 153, 153, 0.25);
  background-color: #fff;
}
.round-box.type5 {
  background-color: #008ead;
}

/* form-box */
/* tf-box */
.tf-box-wrap {
  margin-bottom: 2.8rem;
}
.tf-box label {
  font-size: 1.4rem;
  color: transparent;
}
.tf-box .line-box {
  padding: 0.8rem 0;
  border-bottom: 0.1rem solid #ccc;
}
.tf-box .line-box.type2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.tf-box .line-box .flex-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.tf-box .line-box.type2 .flex-box {
  width: calc(100% - 8.5rem);
}
.tf-box .line-box .tf {
  width: calc(100% - 3rem);
}
.tf-box .line-box .card-num-box {
  gap: 0.4rem;
  width: calc(100% - 3rem);
}
.tf-box .line-box .card-num-box .tf {
  width: 3.8rem;
}
.tf-box .line-box .tf[type="button"] {
  background-color: transparent;
  font-size: 1.6rem;
  color: #919191;
  text-align: left;
}
.tf-box .line-box .remove-btn {
  display: block;
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) repeat center /
    contain;
}
.tf-box .line-box .remove-btn.hidden {
  display: none;
} /* 기본 클래스 hidden을 갖고 있고, input에 값을 입력하기 시작하면 클래스 hidden을 지우고 remove-btn이 나타남 */
.tf-box .line-box .btn-tf {
  width: 7.5rem;
  height: 2.5rem;
  border: 0.1rem solid #ccc;
  border-radius: 1rem;
  background-color: #fff;
  font-size: 1.3rem;
  color: #999;
}
.tf-box .line-box .btn-tf.on {
  border-color: #00b1d8;
  color: #00b1d8;
}
/* input에 focus했을 경우 */
.tf-box.focus label {
  color: #999;
}
.tf-box.focus .line-box {
  border-color: #000;
}
.tf-box.focus .line-box .tf[type="button"] {
  color: #000;
}
.tf-box-wrap .desc {
  margin-top: 1rem;
  font-weight: 500;
  font-size: 1.3rem;
  color: #777;
}

/* textarea-box */
.textarea-box {
  position: relative;
}
.textarea-box label {
  display: block;
  margin-bottom: 1rem;
  font-weight: 500;
  font-size: 1.5rem;
}
.textarea-box textarea {
  width: 100%;
  height: 22.5rem;
  padding: 1.8rem;
  border: 0.1rem solid rgba(204, 204, 204, 0.6);
  border-radius: 1.2rem;
  background-color: #fff;
  color: #2f2f2f;
  white-space: pre-wrap;
}
.textarea-box .total {
  position: absolute;
  bottom: 1.8rem;
  right: 1.8rem;
  font-size: 1.4rem;
  color: #ccc;
}
.textarea-box .total.active {
  color: #222;
}

/* validity-box */
.validity-box-wrap {
  display: flex;
  align-items: center;
  gap: 1.4rem;
}
.validity-box {
  display: flex;
  align-items: center;
  gap: 1.6rem;
}
.validity-box li {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 500;
  font-size: 1.3rem;
  color: #999;
}
.validity-box .ico-check {
  width: 1.8rem;
  height: 1.8rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
/* validity-box 유효할 경우 */
.validity-box.check li {
  color: #00b1d8;
}
.validity-box.check .ico-check {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

/* list-box */
.list-box .list {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list-box .list:not(:last-of-type) {
  margin-bottom: 1.6rem;
}
.list-box .list .tit {
  color: #777;
  word-break: keep-all;
}
.list-box .list .desc {
  font-weight: 500;
  color: #333;
  text-align: right;
  word-break: keep-all;
}
/* .list-box .tit {
  width: 7.4rem;
}
.list-box .desc {
  width: calc(100% - 7.4rem);
} */

/* filter-bar */
.filter-bar {
  position: sticky;
  top: 4rem;
  left: 0;
  z-index: 90;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 2rem;
  background-color: #f6f6f6;
}
.filter-bar .left-box .txt-box {
  display: flex;
  align-items: center;
  gap: 1.6rem;
}
.filter-bar .left-box .txt-box li {
  position: relative;
  font-size: 1.4rem;
  color: #777;
  -webkit-tap-highlight-color: transparent;
}
/* .filter-bar .left-box .btn-tab button.active {
  font-weight: 500;
  color: #000;
} */
.filter-bar .left-box .txt-box li:not(:first-child):before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  left: -0.9rem;
  width: 0.1rem;
  height: 100%;
  background-color: #b2b2b2;
}
.filter-bar .right-box {
  gap: 1.6rem;
}
.filter-bar .ico-filter {
  width: 2.5rem;
  height: 2.5rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat center /
    contain;
}
.filter-bar .ico-search {
  width: 2.5rem;
  height: 2.5rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center /
    contain;
}

/* login page */
.login .title-box {
  margin-bottom: 6rem;
}
.login .title-box h2 {
  font-weight: 400;
}
.login .title-box h2 span {
  display: inline-block;
  position: relative;
  margin-top: 0.6rem;
  font-weight: 500;
  font-size: 2.8rem;
}
.login .title-box h2 strong {
  font-weight: 800;
}
.login .title-box h2 span::after {
  content: "";
  display: inline-block;
  position: absolute;
  bottom: 1rem;
  right: -2.2rem;
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  background: linear-gradient(
    49deg,
    #93d0de 22.26%,
    #bbcef7 66.17%,
    #ecd6d6 105.03%
  );
  opacity: 0.6;
}

/* social-login-box */
.login .social-login-box .tit {
  margin-bottom: 2rem;
  color: #000;
  text-align: center;
}
.login .social-login-box button {
  width: 5rem;
  height: 5rem;
}
.login .social-login-box button.naver {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat
    center / contain;
}
.login .social-login-box button.kakao {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat
    center / contain;
}
.login .social-login-box button.apple {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat
    center / contain;
}

/* find result page */
.find-result .round-box {
  padding: 2.5rem;
}
.find-result .round-box strong {
  display: block;
  margin: 1rem 0 2rem;
  font-weight: 500;
  font-size: 2.3rem;
}
.find-result .round-box p.txt1 {
  color: #777;
}
.find-result .round-box p.txt2 {
  font-size: 1.5rem;
  color: #919191;
}

/* indicator */
.indicator {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.6rem;
}
.indicator li {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  background-color: #f5f6f8;
  color: #00b1d8;
  font-weight: 500;
  font-size: 1.2rem;
}
.indicator li.on {
  background-color: #00b1d8;
  color: #f5f6f8;
}

/* join page */
/* social-join */
.social-join button {
  display: flex;
  align-items: center;
  gap: 1.6rem;
  width: 100%;
  height: 6rem;
  padding: 0 1.6rem;
  border-radius: 1.2rem;
  font-weight: 500;
}
.social-join li:not(:last-child) {
  margin-bottom: 1.2rem;
}
.social-join li:nth-child(1) button {
  background-color: #fde500;
}
.social-join li:nth-child(2) button {
  background-color: #03c759;
  color: #fff;
}
.social-join li:nth-child(3) button {
  background-color: #000;
  color: #fff;
}
.social-join li:nth-child(4) button {
  background-color: #f0f0f0;
}

/* agree-box */
/* all-agree */
.all-agree {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 5rem;
  border-radius: 1.2rem;
  background-color: #f0f0f0;
}
.all-agree input {
  position: absolute;
  top: 50%;
  left: 1.6rem;
  transform: translateY(-50%);
  width: 3rem;
  height: 3rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.all-agree input:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.all-agree span {
  font-weight: 500;
  color: #777;
  letter-spacing: -0.08rem;
}
/* 체크했을 경우 */
.all-agree.check {
  background-color: #000;
}
.all-agree.check span {
  color: #fff;
}

.agree-box .main-agree li {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 1rem;
  -webkit-tap-highlight-color: transparent;
}
.agree-box .main-agree > li {
  position: relative;
  margin-bottom: 1.4rem;
}
.agree-box .main-agree button {
  width: 100%;
  padding: 0.4rem;
  text-align: right;
  z-index: 5;
}
.agree-box .main-agree > li.type2 {
  height: 2.8rem;
}
.agree-box .main-agree > li.type2 button {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: 3.4rem;
  height: 2.8rem;
}
.agree-box .main-agree > li button.type2 {
  position: absolute;
  top: 0;
  right: 0;
  width: 3.4rem;
  height: 2.8rem;
}

.agree-box .main-agree > li > label {
  display: flex;
  align-items: center;
  gap: 1rem;
  position: absolute;
  top: 50%;
  left: 0.4rem;
  z-index: 10;
  transform: translateY(-50%);
  padding-block: 0.5rem;
  padding-right: 1rem;
}
.agree-box .main-agree > li:nth-child(4) > label {
  top: 1.4rem;
}
.agree-box .main-agree > li > label span:not(.main-color) {
  font-size: 1.5rem;
  color: #333;
  letter-spacing: -0.08rem;
}
.agree-box .main-agree input {
  width: 1.8rem;
  height: 1.8rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.agree-box .main-agree input:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.agree-box .main-agree ol {
  padding-left: 2.8rem;
  margin-top: 4rem;
}
.agree-box .main-agree ol label {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  /* padding: 0.6rem 0; */
}
.agree-box .main-agree ol input {
  width: 1.6rem;
  height: 1.6rem;
}
.agree-box .main-agree ol span:not(.main-color) {
  font-size: 1.4rem;
  color: #999;
}

/* phone verification page */

/* room-join page */
/* select-box */
.select-box select {
  width: 100%;
  height: 4.4rem;
  margin-bottom: 1.6rem;
  border-bottom: 0.1rem solid #ccc;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat top
    1rem right / 2rem;
  color: #919191;
}

/* detail-join page */
.detail-join .form-box {
  margin-bottom: 6.4rem;
}
.detail-join .tf-box-wrap {
  margin-bottom: 1.4rem;
}
.detail-join .tf-box input {
  font-size: 1.6rem;
}

/* join-complete page */
.join-complete .content {
  position: relative;
}
.join-complete .title-box h2 {
  line-height: 1.4;
}
.join-complete .title-box h2 span {
  font-size: 2.3rem;
}
.join-complete img.img-building {
  position: fixed;
  bottom: -15.8rem;
  right: 3.7rem;
  display: block;
  width: 19.4rem;
  height: 22.4rem;
  animation: slide-up 0.55s ease 0.35s forwards;
}
@keyframes slide-up {
  0% {
    bottom: -15.8rem;
  }
  100% {
    bottom: 5.4rem;
  }
}
.join-complete .fixed-button-box {
  padding-top: 0;
}

/* menu page */
/* user-profile-box */
.user-profile-box {
  display: flex;
  align-items: center;
  gap: 1.8rem;
}
.user-profile-box img {
  width: 5rem;
  height: 5rem;
  border-radius: 1.5rem;
  background-color: #ededed;
  object-fit: cover;
  font-size: 1.3rem;
  line-height: 1.2;
  word-break: keep-all;
}
.user-profile-box button {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}
.user-profile-box button .txt {
  font-weight: 500;
  font-size: 2rem;
}
.user-profile-box.sns button .txt {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-weight: 400;
  font-size: 1.8rem;
}

/* menu-box */
.menu-box {
  padding: 2rem 0;
}
.menu-box h4 {
  margin-bottom: 1.2rem;
}
.menu-box ul .main-menu {
  padding: 0.6rem 0;
}
.menu-box ul .main-menu button,
.menu-box ul .main-menu .no-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.menu-box ul .main-menu button span,
.menu-box ul .main-menu .no-btn span {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  font-weight: normal;
  font-size: 1.7rem;
  color: #777;
}
.menu-box ul li ol {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  margin: 0.8rem 2rem 0 4rem;
  padding: 0.6rem 0;
}
.menu-box ul li ol .sub-menu {
  width: calc((100% - 1rem) / 2);
}
.menu-box ul li ol .sub-menu button {
  display: block;
  width: 100%;
  height: 4.5rem;
  border-radius: 1.5rem;
  background-color: #ecf6f9;
  font-size: 1.5rem;
  color: #333;
}

.menu .round-box {
  padding: 2.4rem 1.6rem;
}
.menu .round-box p.txt1 {
  margin-bottom: 0.8rem;
  color: #777;
}
.menu .round-box p.txt2 {
  font-weight: 500;
  font-size: 1.8rem;
}
.menu .round-box p.txt2 span {
  font-weight: 400;
  font-size: 1.5rem;
  color: #222;
}

/* user info page */
/* user-profile-box */
.user-info .user-profile-box {
  flex-direction: column;
}
.user-info .user-profile-box .img-box {
  position: relative;
}
.user-info .user-profile-box img {
  width: 10rem;
  height: 10rem;
  border-radius: 3.2rem;
  background-color: #ededed;
  object-fit: cover;
  font-size: 1.3rem;
  line-height: 1.2;
  word-break: keep-all;
}
.user-info .user-profile-box .ico-round-camera {
  position: absolute;
  bottom: -0.3rem;
  right: -0.5rem;
  width: 3rem;
  height: 3rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

/* info-box */
.user-info .info-box {
  position: relative;
  padding: 3rem 2rem;
  border-top: 0.5rem solid #f6f6f6;
}
.user-info .exp {
  margin: 0.5rem 0 4rem;
  padding: 0 2.8rem 0 2rem;
  /* border-top: 0.1rem solid #ebebeb; */
  font-size: 1.4rem;
  color: #b2b2b2;
  line-height: 1.4;
  word-break: keep-all;
}
.user-info .exp em {
  font-style: normal;
  color: #ff2424;
}
.user-info .info-box .info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
}
.user-info .info-box .info:not(:last-child) {
  margin-bottom: 3rem;
}
.user-info .info-box .info .tit {
  width: 9rem;
  font-size: 1.5rem;
  color: #999;
}
.user-info .info-box .info .desc {
  display: flex;
  justify-content: space-between;
  align-self: flex-end;
  align-items: center;
  width: calc(100% - 11rem);
}
.user-info .info-box .info .desc p {
  width: calc(100% - 4rem);
  font-size: 1.7rem;
}
.user-info .info-box .info .desc .modification-btn {
  width: 4rem;
  height: 2.25rem;
  background-color: #f6f6f6;
  border-radius: 2.5rem;
  font-size: 1.4rem;
  color: #00b1d8;
}
.user-info .info-box .info .desc .alert-btn {
  width: 2.2rem;
  height: 2.2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat center /
    contain;
}

/* setting page */
/* switch-btn */
.setting .switch-btn-wrap {
  padding: 0.8rem 0;
}
.setting .switch-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
}
.setting .switch-btn span {
  font-weight: 500;
  color: #777;
}
.setting .switch-btn input {
  position: relative;
  width: 5rem;
  height: 2.8rem;
  border-radius: 2.8rem;
  background-color: #ccc;
  box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.25) inset;
}
.setting .switch-btn input::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0.2rem;
  left: 0.2rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.25);
  transition: left 0.4s ease;
}
.setting .switch-btn input:checked {
  background-color: #00b1d8;
}
.setting .switch-btn input:checked::before {
  left: calc(100% - 2.6rem);
}

/* bar-btn */
.bar-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

/* version-info-box */
.setting .bar-btn {
  height: 4rem;
}

.setting .version-info-box {
  position: fixed;
  bottom: 2.8rem;
  left: 50%;
  transform: translateX(-50%);
  margin: auto;
  text-align: center;
}
.setting .version-info-box span {
  font-size: 1.5rem;
}
.setting .version-info-box p {
  margin-top: 1.4rem;
  font-size: 1.5rem;
}

/* withdrawal page */
.withdrawal .terms-box {
  height: 30rem;
  padding: 2.4rem 1.6rem;
}
.withdrawal .terms-box .scroll-box {
  height: 100%;
  overflow-y: scroll;
}
.withdrawal .terms-box .desc-terms {
  font-size: 1.5rem;
  color: #777;
}

/* notice page */
.notice .notice-box {
  margin-bottom: 2.4rem;
}
.notice .notice-box .round-box {
  padding: 1.6rem;
}
.notice .notice-box:first-of-type .round-box {
  background-color: #f3fbff;
}
.notice .notice-box .round-box .txt-box {
  height: 10.4rem;
  overflow: hidden;
}
.notice .notice-box .round-box .txt-box.open {
  height: auto;
  overflow: auto;
}
.notice .notice-box .round-box .txt-box .tit {
  margin-bottom: 1.4rem;
  font-weight: 500;
  font-size: 1.7rem;
  color: #222;
  line-height: 1.32;
}
.notice .notice-box .round-box .txt-box .desc {
  font-size: 1.5rem;
  color: #5e5e5e;
  line-height: 1.52;
  word-break: keep-all;
  white-space: pre-wrap;
}
.notice .notice-box .round-box .down-btn {
  margin-top: 1.4rem;
  width: 100%;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat center /
    contain;
}
.notice .notice-box .round-box .down-btn.active {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.notice .notice-box .date {
  display: block;
  margin-bottom: 1.6rem;
  font-size: 1.5rem;
  color: #555;
}
.notice .notice-box .time {
  display: block;
  margin-top: 0.8rem;
  font-size: 1.4rem;
  color: #222;
  text-align: right;
}

/* payment method page */
/* method-box */
.payment-method .method-box .title-box h2 {
  font-size: 1.8rem;
}
.payment-method .method-box button.cancel {
  background-color: #ff7070 !important;
}
/* card-box */
.method-box .card-box {
  position: relative;
  height: 15.4rem;
  padding: 3rem 3rem 2.5rem;
}
.method-box .card-box::before {
  content: "";
  display: block;
  position: absolute;
  top: -6.6rem;
  right: 0;
  width: 10.4rem;
  height: 6.6rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat
    center / contain;
}
.method-box .no-card .txt-box {
  text-align: center;
}
.method-box .no-card .txt-box p {
  margin-top: 2rem;
  font-size: 1.5rem;
  color: #555;
}
.method-box .no-card .txt-box .ico-warning {
  width: 4rem;
  height: 4rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.method-box.no-regi .btn1 {
  gap: 0.8rem;
  width: -moz-fit-content;
  width: fit-content;
  padding: 0 2rem;
  border: 0.1rem solid #999;
  background-color: #fff;
}
.method-box.no-regi .btn1 .ico-plus {
  width: 1.6rem;
  height: 1.6rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

.payment-method .round-box {
  padding: 2.4rem 1.8rem;
}

/* registration complete page */
.registration-complete .title-box {
  text-align: center;
}
.registration-complete .title-box h2 {
  font-size: 2.3rem;
}

/* claim history page */
/* maintenance-cost-box & history-list */
.maintenance-cost-box-wrap {
  position: fixed;
  top: 4rem;
  left: 0;
  z-index: 9;
  width: 100%;
  padding: 2rem;
  background-color: #fff;
}
.maintenance-cost-box {
  padding: 2rem;
  background-color: #fff;
  box-shadow: 0 0 0.4rem 0 rgba(0, 0, 0, 0.25);
  cursor: pointer;
}
.history-box {
  margin-top: 21.4rem;
}

.maintenance-cost-box .state,
.history-list .state {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.5rem;
  height: 2.6rem;
  border: 0.1rem solid #000;
  border-radius: 2.6rem;
  font-weight: 500;
  font-size: 1.3rem;
}
.maintenance-cost-box .state.red,
.history-list .state.red {
  border: 0.1rem solid #ff2424;
  color: #ff2424;
}
.maintenance-cost-box .state.blue,
.history-list .state.blue {
  border: 0.1rem solid #242dff;
  color: #242dff;
}

.maintenance-cost-box {
  position: relative;
  padding-bottom: 7.8rem;
  transition: all 0.3s;
}
.maintenance-cost-box.hidden {
  transition: all 0.5s;
  padding-bottom: 2.5rem;
}
.maintenance-cost-box .cost {
  font-size: 3.2rem;
  text-align: right;
}
.maintenance-cost-box .cost strong {
  font-weight: 700;
}
.maintenance-cost-box .due-date-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 2rem;
  left: 2rem;
  width: calc(100% - 4rem);
  padding: 1.2rem 1.5rem;
  border-radius: 1.2rem;
  background-color: #00b1d8;
  transition: all 1.7s;
}
.maintenance-cost-box .due-date-bar.hidden {
  transition: all 0.2s;
  opacity: 0;
}
.maintenance-cost-box .due-date-bar .tit {
  font-size: 1.5rem;
  color: #fff;
}
.maintenance-cost-box .due-date-bar .desc {
  font-weight: 500;
  font-size: 1.8rem;
  color: #fff;
}

.history-list .list {
  padding: 2rem 0;
  position: relative;
  cursor: pointer;
}
.history-list .list::after {
  content: "";
  display: block;
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 4.6rem);
  height: 0.1rem;
  background-color: #ccc;
}
.history-list .list:last-of-type::after {
  content: none;
}
.history-list .list .month {
  color: #777;
}
.history-list .list .cost {
  margin-top: 1.6rem;
  font-size: 1.8rem;
  color: #333;
  text-align: right;
}

/* history detail page */
.history-detail .content {
  background-color: #f0f0f0;
}
.history-detail .maintenance-cost-box {
  width: 100%;
  height: 18rem;
  box-shadow: 0 0 0.4rem 0 rgba(153, 153, 153, 0.25);
}
.history-detail .section1 .list-box {
  padding: 2.4rem 0 1.4rem;
}
.history-detail .section1 .list-box.hidden {
  height: 12rem;
  overflow-y: hidden;
}
.history-detail .section3 .list-box .list {
  margin-bottom: 0.5rem;
  padding: 1.2rem 1.6rem;
  border-radius: 1.2rem;
  background-color: #f6f6f6;
}
.history-detail .section3 .list-box .list p {
  font-weight: 400;
  color: #555;
}
.history-detail .section3 .list-box .list p.tit {
  font-size: 1.5rem;
}

/* detail-tab-box */
.history-detail .detail-tab-box {
  position: relative;
  overflow: hidden;
  width: 100%;
  /* height: calc(100vh - 28rem); */
  border-radius: 1.2rem;
  background-color: #fff;
}
.history-detail .detail-tab-box .tab {
  padding: 0.5rem;
}
.history-detail .detail-tab-box .tab .tab-button {
  width: calc(100% / 2);
  height: 4rem;
  border-radius: 1.2rem;
  background-color: #fff;
  font-size: 1.5rem;
  color: #888;
}
.history-detail .detail-tab-box .tab .tab-button.active {
  background-color: #dbf4ff;
  font-weight: 500;
  color: #000;
}
.history-detail .detail-tab-box .tab-content {
  padding: 2rem;
}
.history-detail .detail-tab-box .section-box h2 {
  font-size: 1.8rem;
}
.history-detail .chart-box .total-number {
  gap: 4rem;
}
.history-detail .chart-box .total-number li {
  font-size: 1.5rem;
  color: #555;
}
.history-detail .chart-box .total-number li .number {
  display: block;
  margin-top: 1rem;
  font-weight: 600;
  font-size: 1.8rem;
  color: #000;
}
.history-detail .detail-tab-box .button-box .btn1 {
  border-radius: 0 0 1.2rem 1.2rem;
}

.history-detail2 .round-box {
  padding: 2rem;
  background: #f6f6f6 url(${___CSS_LOADER_URL_REPLACEMENT_24___}) no-repeat top
    29.8rem left 0 / contain;
  box-shadow: none;
}
.history-detail2 .title-box h2 {
  font-size: 1.7rem;
  line-height: 1.6;
}
.history-detail2 .title-box h2 span {
  display: block;
  font-weight: 400;
  font-size: 3.2rem;
}
.history-detail2 .list-box-wrap h2 {
  font-size: 1.8rem;
}
.history-detail2 .list-box.type2 .list {
  padding: 1.2rem 1.6rem;
  margin-bottom: 0.8rem;
  border-radius: 1.2rem;
  background-color: #fff;
}
.history-detail2 .list-box.type2 .list .tit {
  color: #000;
}
.history-detail2 .list-box.type2 .list .desc {
  color: #555;
}

/* payment page */
.payment .title-box h2 {
  font-size: 1.7rem;
  line-height: 1.6;
}
.payment .title-box h2 span {
  display: block;
  font-weight: 400;
  font-size: 3.2rem;
}

.payment .round-box {
  padding: 2rem;
}
.payment .list-box .tit {
  width: 7.4rem;
}
.payment .list-box .desc {
  width: calc(100% - 7.4rem);
}
.payment .bar-btn {
  margin-top: 2.5rem;
}
.payment .bar-btn h3 {
  font-size: 1.8rem;
}

/* payment detail page */
.payment-detail .title-box .img-payment {
  display: block;
  width: 13rem;
  height: 11.5rem;
  margin: 0 auto 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) no-repeat center /
    contain;
}
.payment-detail .title-box h2 {
  text-align: center;
}
.payment-detail .title-box h2 strong {
  font-weight: 500;
}

/* card-box */
.card-box {
  position: relative;
  height: 15.4rem;
  padding: 3rem 3rem 2.5rem;
}
.card-box .card-info-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.card-box .card-info-box p {
  font-weight: 500;
}
.card-box .card-info-box p.com {
  align-self: flex-start;
  font-size: 1.5rem;
}
.card-box .card-info-box p.num {
  font-size: 1.8rem;
}
.card-box .card-info-box p.expi-date {
  align-self: flex-end;
}
.card-box .card-info-box.wh-color p {
  color: #fff;
}
.card-box .remove-btn {
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center /
    contain;
}

/* payment complete page */
.payment-complete .title-box {
  text-align: center;
}
.payment-complete .title-box .cost {
  font-size: 2.3rem;
  font-weight: 500;
}

.payment-complete .content .button-box {
  text-align: center;
}
.payment-complete .content .btn1 {
  width: -moz-fit-content;
  width: fit-content;
  padding: 0 3.6rem;
}

/* payment history */
.payment-history .round-box {
  height: 9rem;
  margin: 2rem;
  padding: 1rem;
}
.payment-history .hidden-box {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 5rem;
}
.payment-history .rolling-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  animation: rolling 6.4s infinite ease;
}
.payment-history .rolling-box p {
  font-weight: 500;
  font-size: 1.8rem;
  color: #fff;
  text-align: center;
  line-height: 1.4;
}
@keyframes rolling {
  7% {
    top: 0;
  }
  50% {
    top: -7.2rem;
  }
}

.payment-history .history-list .list {
  padding: 2rem;
}
.payment-history .history-list .list::after {
  content: none;
}
.payment-history .history-list .list .txt1,
.payment-history .history-list .list .txt2 {
  font-size: 1.5rem;
  color: #555;
}
.payment-history .history-list .list .txt3 {
  font-size: 1.5rem;
  color: #999;
}
.payment-history .history-list .list .cost {
  margin-top: 0;
}
.payment-history .history-list .list .cost span {
  font-weight: 500;
}

/* .payment history detail page */
.history-detail-payment .round-box.box1 {
  margin: 2rem;
  padding: 2rem;
}
.history-detail-payment .round-box.box1 .txt2 {
  font-size: 3.2rem;
  text-align: right;
}
.history-detail-payment .list-box-wrap {
  padding: 2rem;
}
.history-detail-payment .round-box.box1 .list-box .tit {
  width: 7.4rem;
}
.history-detail-payment .round-box.box1 .list-box .desc {
  width: calc(100% - 7.4rem);
}
.history-detail-payment hr {
  width: 100%;
  height: 0.1rem;
  background-color: rgba(204, 204, 204, 0.2);
}
.history-detail-payment .round-box.box2 {
  margin: 2rem;
  margin-top: 1rem;
  padding: 2rem;
}
.history-detail-payment .round-box.box2 p {
  font-size: 1.5rem;
  color: #777;
  line-height: 1.5;
  word-break: keep-all;
}

/* community main pages */
/* category-box */
.category-box {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 2rem;
}
.category-box li {
  width: calc((100% - 4rem) / 3);
}
.category-box li button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  width: 100%;
  font-weight: 500;
  font-size: 1.5rem;
  word-break: keep-all;
}

/* banner */
.banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem 0 3rem;
  border-radius: 1.2rem;
  width: 100%;
  height: 8rem;
  background: #dbf4ff url(${___CSS_LOADER_URL_REPLACEMENT_26___}) no-repeat
    bottom right 5rem / 9.5rem 5.9rem;
}
.banner p {
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 1.34;
}

/* ranking-list & today-list */
.ranking-list-wrap {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) no-repeat top right /
    7.2rem 4.2rem;
}
.today-list-wrap {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) no-repeat top 0.4rem
    right 2rem / 4.2rem 4.2rem;
}
.ranking-list-wrap h2,
.today-list-wrap h2 {
  margin-bottom: 1.6rem;
  font-weight: 600;
  font-size: 1.8rem;
}
.ranking-list .list,
.today-list .list-box {
  padding: 1.6rem;
  box-shadow: 0 0 0.25rem 0 rgba(0, 0, 0, 0.25);
  cursor: pointer;
}
.ranking-list .list:not(:last-child),
.today-list .list-box:not(:last-child) {
  margin-bottom: 1rem;
}

.ranking-list .list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.8rem;
  background-color: #fff;
}
.ranking-list .list:first-child {
  background-color: #fdf4f2;
  border: 0.1rem solid #fbca33;
}
.ranking-list .list .number-box {
  width: 3.8rem;
  height: 3.8rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.ranking-list .list:nth-child(1) .number-box {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}
.ranking-list .list:nth-child(2) .number-box {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}
.ranking-list .list:nth-child(3) .number-box {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}
.ranking-list .list .desc-box {
  width: calc(100% - 12.2rem);
}
.ranking-list .list .desc-box .txt1 {
  margin-bottom: 0.8rem;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.34;

  /* 밀즐임 - 두줄 이상일 경우 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.ranking-list .list:first-child .desc-box .txt1 {
  color: #ff2424;
}
.ranking-list .list .desc-box .txt2 {
  font-size: 1.3rem;
  color: #555;
}
.ranking-list .list .desc-box .txt2 .category {
  position: relative;
  margin-right: 2rem;
}
/* .ranking-list .list .desc-box .txt2 .category::after {
  content: "";
  display: inline-block;
  right: -1rem;
  position: absolute;
  width: 0.1rem;
  height: 1.3rem;
  background-color: #555;
} */
.ranking-list .list .view-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  width: 5rem;
}
.ranking-list .list .view-box .ico-view {
  width: 1.6rem;
  height: 1.4rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}
.ranking-list .list .view-box .num {
  font-weight: 500;
  font-size: 1.2rem;
}

.today-list .list .category-name {
  display: inline-block;
  margin-bottom: 1.2rem;
  padding: 0.6rem 2rem;
  border-radius: 0.7rem;
  background-color: #ffdbfe;
}
.today-list .list .txt2 {
  font-weight: 500;
  font-size: 1.6rem;
  color: #333;
  line-height: 1.2;
}

/* community pages */
/* no-content */
.no-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  width: 100%;
  height: 20rem;
}
.no-content.type2 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: auto;
}
.no-content p {
  font-size: 1.6rem;
  color: #797979;
}
.ico-no-content {
  width: 4.2rem;
  height: 4rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}

/* num-box */
.num-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1.6rem;
}
.num-box.type3 {
  padding: 0 2rem;
}
.num-box li {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 500;
  font-size: 1.2rem;
  color: #555;
}
.num-box.type2 li {
  font-size: 1.4rem;
}
.num-box li i {
  width: 1.6rem;
  height: 1.4rem;
}
.num-box.type2 li i {
  width: 1.8rem;
  height: 1.5rem;
}
.num-box .ico-view {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}
.num-box .ico-like {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}
.num-box button.ico-like {
  width: 1.8rem;
  height: 1.5rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) no-repeat center /
    contain;
}
.num-box button.ico-like.active {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
.num-box .ico-comment {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}

/* tab-community */
.community .tab-community {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  position: sticky;
  top: 4rem;
  left: 0;
  width: 100%;
  padding: 1.4rem;
  background-color: #fff;
  z-index: 9;
}
.community .tab-community button {
  height: 4.4rem;
  width: 8.2rem;
  font-weight: 600;
  font-size: 1.7rem;
  color: #ccc;
}
.community .tab-community button.active {
  color: #000;
}

/* notice-community */
.ico-notice {
  width: 2.5rem;
  height: 2.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}
.notice-community {
  border-top: 0.05rem solid #ddd;
}
.notice-community .item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 2rem;
  border-bottom: 0.05rem solid #ddd;
  background-color: #fff;
}

/* community-list */
.community-list,
.inq-list {
  padding-bottom: 2rem;
}
.community-list .list-box,
.inq-list .list-box {
  padding: 2rem;
  border-bottom: 0.1rem solid rgba(204, 204, 204, 0.2);
  cursor: pointer;
}
.inq-list .list-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.community-list .list-box:last-child,
.inq-list .list-box:last-child {
  border-bottom: 0;
}
.community-list .list-box .left-box,
.inq-list .list-box .left-box {
  width: calc(100% - 7rem);
}
.community-list .list-box .txt1,
.inq-list .list-box .txt1 {
  margin-bottom: 0.6rem;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.community-list .list-box .txt2,
.inq-list .list-box .txt2 {
  font-size: 1.4rem;
  color: #999;
}

.community-list2 .list-box {
  display: flex;
  align-items: center;
  gap: 1.8rem;
  cursor: pointer;
}
.community-main .today-list .list-box {
  display: flex;
  gap: 2rem;
  padding: 1.6rem;
}
.community-list2 .list-box img,
.community-main .today-list .list-box img {
  display: block;
  width: 10rem;
  height: 10rem;
  border-radius: 1.2rem;
  background-color: #eee;
  object-fit: cover;
}
.community-main .today-list .list-box img {
  width: 7.8rem;
  height: 7.8rem;
}
.community-list2 .list-box .desc-box {
  width: calc(100% - 11.8rem);
}
.community-main .today-list .list-box .desc-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: calc(100% - 9.8rem);
}
.community-list2 .list-box .desc-box .txt-box .price {
  margin-top: 1rem;
  font-weight: 600;
  font-size: 1.8rem;
  color: #333;
}
.community-main .today-list .list-box .desc-box .txt-box .sort {
  font-style: normal;
  font-size: 1.4rem;
}
/* 커뮤니티 카테고리별 컬러 */
.today-list .sort.sell {
  color: #6155ef;
}
.today-list .sort.buy {
  color: #e756f0;
}
.today-list .sort.knowledge {
  color: #f55979;
}
.today-list .sort.building {
  color: #f0bb56;
}
.today-list .sort.job {
  color: #54c2e2;
}
.today-list .sort.free {
  color: #8356ce;
}

.community-main .today-list .list-box .desc-box .txt-box .txt {
  margin-top: 0.8rem;
  font-weight: 500;
  color: #333;
  width: 100%;
  /* 말줄임 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.community-list2 .list-box .num-box {
  margin-top: 1.6rem;
}

.community-list3 .list-box .txt1 {
  margin-bottom: 2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* writing-btn */
.writing-btn {
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  z-index: 9;
}
.writing-btn button {
  gap: 0.5rem;
  width: 8.5rem;
  height: 4rem;
  border-radius: 2rem;
  background-color: #008ead;
  font-weight: 600;
  font-size: 1.5rem;
  color: #fff;
}
.writing-btn .ico-plus-white {
  width: 1.2rem;
  height: 1.2rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

/* detail */
.user-box .user {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.user-box .user img {
  width: 3rem;
  height: 3rem;
  object-fit: cover;
  border-radius: 0.9rem;
}
.user-box .user span {
  font-weight: 700;
  font-size: 1.5rem;
}
.user-box .txt1 {
  margin-bottom: 1.2rem;
  font-weight: 500;
  line-height: 1.32;
}
/* 말줄임 */
/* width: calc(100% - 3.2rem);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; */
.user-box .txt2 {
  font-size: 1.4rem;
  color: #999;
}
.edit-btn {
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_39___}) no-repeat center /
    contain;
}

.detail-img-box {
  padding: 2rem;
}

.detail-desc-box {
  padding: 2rem;
  border-top: 0.1rem solid rgba(204, 204, 204, 0.2);
}
.detail-desc-box .price {
  display: block;
  margin-bottom: 2rem;
  font-weight: 600;
  font-size: 1.8rem;
  color: #333;
}
.detail-desc-box p {
  font-size: 1.5rem;
  color: #333;
  line-height: 1.4;
  white-space: pre-wrap;
}

.regit-box label {
  display: block;
  margin-bottom: 1rem;
  font-weight: 500;
  font-size: 1.5rem;
}
.regit-box textarea {
  display: block;
  width: 100%;
  height: 7.8rem;
  padding: 1.4rem 1.6rem;
  border: 0.1rem solid rgba(204, 204, 204, 0.6);
  border-bottom: 0;
  border-radius: 1.2rem 1.2rem 0 0;
  background-color: #fff;
  color: #333;
  line-height: 1.24;
  white-space: pre-wrap;
}
.regit-box textarea::placeholder {
  font-size: 1.5rem;
  color: #ccc;
}
.regit-box .btn-box button {
  width: 100%;
  height: 4rem;
  border-radius: 0 0 1.2rem 1.2rem;
  background-color: #000;
  font-size: 1.5rem;
  color: #fff;
}
.regit-box .btn-box.type2 button {
  border-radius: 0 0 0 1.2rem;
  background-color: #555;
}
.regit-box .btn-box.type2 button.main {
  border-radius: 0 0 1.2rem 0;
  background-color: #00b1d8;
}

/* comment-box */
.comment-box-wrap .comment-top-box {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1.6rem 2rem;
}
.comment-box-wrap .comment-top-box .ico-comment2 {
  width: 1.4rem;
  height: 1.4rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.comment-box-wrap .comment-top-box span {
  font-weight: 500;
  font-size: 1.4rem;
}
.comment-box {
  padding: 2rem;
  border-top: 0.1rem solid rgba(204, 204, 204, 0.2);
}
.comment-box .txt1 {
  font-size: 1.6rem;
  color: #333;
  line-height: 1.4;
  white-space: pre-wrap;
}
.comment-box .reply-btn {
  width: 5.5rem;
  height: 3rem;
  border-radius: 0.6rem;
  background-color: #d9d9d9;
  font-size: 1.4rem;
}

/* reply-box */
/* .reply-box-wrap {
  margin: 0 2rem;
  padding: 2rem;
} */
.reply-box {
  padding: 2rem;
  background-color: #f3fbff;
}
.reply-box .flex-box {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.reply-box .flex-box .left-box {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  width: calc(100% - 3rem);
}
.reply-box .flex-box .left-box .user-box {
  width: calc(100% - 2.2rem);
}
.reply-box .icon-reply {
  width: 1.2rem;
  height: 1.8rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}
.reply-box .txt1 {
  margin-bottom: 0;
  font-size: 1.5rem;
  white-space: pre-wrap;
}

/* attachment */
.attachment {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  column-gap: 1rem;
  row-gap: 2.8rem;
}
.attachment .file-btn {
  width: 7rem;
  height: 7rem;
  border-radius: 0.8rem;
  background: #333 url(${___CSS_LOADER_URL_REPLACEMENT_42___}) no-repeat top
    1.7rem center / 2rem;
}
.attachment .file-btn .total {
  margin-top: 2.2rem;
  display: block;
  font-size: 1.4rem;
  color: #fff;
  text-align: center;
}
.attachment .file-box {
  position: relative;
  width: 7rem;
  height: 7rem;
  /* padding: 0.4rem 0.2rem; */
  border: 0.1rem solid #ddd;
  border-radius: 0.8rem;
  background-color: #eee;
  font-size: 1.3rem;
  color: #444;
}
.attachment .file-box img {
  width: 100%;
  height: 100%;
  border-radius: 0.8rem;
  object-fit: cover;
}
.attachment .file-box.represent span {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2.5rem;
  border-radius: 0 0 0.8rem 0.8rem;
  background-color: rgba(0, 0, 0, 0.6);
  font-size: 1.4rem;
  color: #fff;
  text-align: center;
  line-height: 2.5rem;
}
.attachment .file-box .remove-btn {
  display: block;
  position: absolute;
  bottom: -2.2rem;
  right: 0;
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) repeat center /
    contain;
}
.attachment .ico-camera {
  width: 2.4rem;
  height: 1.6rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}

/* inq-agree-box */
.inq-agree-box h2 {
  margin-bottom: 1.2rem;
  font-size: 1.5rem;
  color: #555;
}
.inq-agree-box .round-box {
  padding: 1.5rem;
  border: 0.1rem solid rgba(204, 204, 204, 0.6);
  box-shadow: none;
}
.inq-agree-box .round-box p {
  width: 100%;
  height: 8.8rem;
  overflow-y: scroll;
  font-size: 1.4rem;
  color: #777;
  line-height: 1.4;
}
.inq-agree-box .inq-agree input {
  width: 2.5rem;
  height: 2.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.inq-agree-box .inq-agree input:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
}
.inq-agree-box .inq-agree {
  gap: 0.5rem;
}
.inq-agree-box .inq-agree label {
  color: #777;
}

/* inq-tit-box */
.inq-tit-box {
  padding: 1.6rem 2rem;
  border-bottom: 0.1rem solid rgba(204, 204, 204, 0.2);
}
.inq-tit-box .txt1 {
  font-weight: 500;
  color: #333;
  line-height: 1.4;
}
.inq-tit-box .txt2,
.inq-reply-box .txt2 {
  font-size: 1.4rem;
  color: #999;
}
.inq-tit-box .sort {
  font-style: normal;
  font-weight: 500;
  font-size: 1.4rem;
  color: #d80000;
}
.inq-tit-box .sort.type2 {
  display: inline-block;
  padding: 0.6rem 2rem;
  border-radius: 0.6rem;
  background-color: #f6f6f6;
}
.inq-list .state,
.inq-tit-box .state {
  display: block;
  padding: 0.6rem 0.8rem;
  background-color: #f6f6f6;
  border-radius: 4rem;
  font-size: 1.4rem;
  color: #999;
}

/* inq-desc-box */
.inq-desc-box {
  min-height: 15rem;
  padding: 1.6rem 2rem;
  border-bottom: 0.1rem solid rgba(204, 204, 204, 0.2);
}
.inq-desc-box img {
  display: block;
  width: 100%;
  height: 20rem;
  border: 0.1rem solid #eee;
  border-radius: 1.2rem;
  object-fit: cover;
}
.inq-desc-box p {
  font-size: 1.5rem;
  color: #777;
  line-height: 1.4;
  white-space: pre-wrap;
}

/* inq-reply-box */
.inq-reply-box {
  padding: 1.6rem 2rem;
}
.inq-reply-box .round-box {
  min-height: 15rem;
  padding: 1.6rem;
}
.inq-reply-box p {
  font-size: 1.4rem;
  color: #555;
  line-height: 1.5;
  white-space: pre-wrap;
}

/* office-info */
.office-info img {
  display: block;
  width: 10rem;
  height: 10rem;
  margin: auto;
  /* border-radius: 3rem; */
  object-fit: contain;
}
.office-info .info-box .info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.office-info .info-box .info:not(:last-child) {
  margin-bottom: 1.6rem;
}
.office-info .info-box .info p {
  color: #333;
}
.office-info .info-box .info p.txt2 {
  font-weight: 500;
}

/* to-modal-btn */
.to-modal-btn {
  width: 100%;
  padding: 1.2rem 0;
  border-bottom: 0.1rem solid #ccc;
  text-align: left;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat top
    0.8rem right / 2rem;
  color: #2f2f2f;
  /* outline: none; */
}
.to-modal-btn.active {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.to-modal-btn2 {
  gap: 0.5rem;
  color: #444;
}
.to-modal-btn2 .ico-down-arr {
  width: 1.8rem;
  height: 1.8rem;
}

/* advertisement page */
.advertisement h2 {
  font-weight: 400;
  font-size: 1.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.advertisement .ad-box:not(:last-child) {
  margin-bottom: 3rem;
}
.advertisement .ad-box img {
  display: block;
  width: 100%;
  height: 9rem;
  border: 0.1rem solid #dfdfdf;
  border-radius: 1.2rem;
  background-color: #efefef;
  object-fit: cover;
  margin: 1.2rem 0;
  font-size: 1.5rem;
}
.advertisement .ad-box .txt2 {
  font-size: 1.4rem;
  color: #999;
}

/* advertisement detail page */
.advertisement-detail h2 {
  font-weight: 400;
  font-size: 1.6rem;
  word-break: keep-all;
}
.advertisement-detail img {
  display: block;
  width: 100%;
  height: calc((100vh / 3) * 2);
  border-radius: 1.2rem;
  background-color: #ddd;
  object-fit: cover;
  margin: 1.2rem 0;
  font-size: 1.5rem;
}
.advertisement-detail .txt2 {
  font-size: 1.4rem;
  color: #999;
}

/* image-modal */
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  z-index: 300;
}
.image-modal .top {
  position: relative;
  height: 4.8rem;
  padding: 0 2rem;
}
.image-modal .top .indi {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  color: #fff;
}
.image-modal .top .back-btn {
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_44___}) no-repeat center /
    contain;
}
.image-modal .image-box {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;
}
.image-modal .image-box img {
  width: 100%;
  object-fit: contain;
}

/* alert-modal */
.alert-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 300;
}
.alert-modal .box {
  width: 100%;
  max-width: 28rem;
  padding: 2rem;
  border-radius: 1.2rem;
  background-color: #fff;
}
.alert-modal .top {
  text-align: right;
}
.alert-modal .close-btn {
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center /
    contain;
}
.alert-modal .icon-box {
  margin: 1rem 0 2.5rem;
  text-align: center;
}
.alert-modal .icon-box .ico-cas {
  width: 8.4rem;
  height: 6rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_45___}) no-repeat center /
    contain;
}
.alert-modal .desc {
  width: 20rem;
  margin: 1.8rem auto 2.8rem;
}
.alert-modal .desc p {
  font-size: 1.5rem;
  color: #777;
  line-height: 1.6;
  text-align: center;
  word-break: keep-all;
  white-space: pre-wrap;
}
.alert-modal .desc p.type2 {
  color: #000;
}
.alert-modal .desc p .point {
  color: #ff2424;
}
.alert-modal .button-box {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}
.alert-modal .btn1 {
  height: 4.4rem;
}

/* bottom-modal */
.bottom-sheet-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 250;
}
.bottom-sheet-modal .box {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 2rem 2rem 0 0;
  background-color: #fff;
}
.bottom-sheet-modal.type1 .box {
  height: 34rem;
}
.bottom-sheet-modal.type2 .box {
  height: 22.8rem;
}
.bottom-sheet-modal.type3 .box {
  height: 12.2rem;
}
.bottom-sheet-modal .tit-box {
  padding: 2rem 2rem 1rem;
}
.bottom-sheet-modal .tit-box h2 {
  font-weight: 600;
}
.bottom-sheet-modal .close-btn {
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center /
    contain;
}
.bottom-sheet-modal .con-box {
  height: calc(100% - 5.4rem);
  overflow-y: scroll;
}
.bottom-sheet-modal .con-box.type2 {
  padding-top: 1rem;
  padding-inline: 2rem;
  padding-bottom: 10rem;
}
.bottom-sheet-modal .con-box.type3 {
  padding-bottom: 8.8rem;
}
.bottom-sheet-modal.type2 .con-box {
  height: calc(100% - 5rem);
}
.bottom-sheet-modal .con-box .flex-box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-block: 1.4rem;
}
.bottom-sheet-modal .con-box .year-box {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  width: 8rem;
}
.bottom-sheet-modal .con-box .year-box button.prev {
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat center /
    contain;
}
.bottom-sheet-modal .con-box .year-box button.next {
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat center /
    contain;
}
.bottom-sheet-modal .con-box .year-box span {
  display: block;
  padding: 1rem;
  font-weight: 500;
  font-size: 2rem;
  color: #333;
}
.bottom-sheet-modal .con-box .month-box {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  width: 16.2rem;
}
.bottom-sheet-modal .con-box .month-box button {
  width: 5rem;
  height: 5rem;
  border-radius: 1.2rem;
  background-color: #f6f6f6;
  font-size: 1.6rem;
  color: #777;
}

/* 해당 월 - button태그에 active 클래스 추가 */
.bottom-sheet-modal .con-box .month-box button.active {
  background-color: #dbf4ff;
  color: #00b1d8;
}
/* 해당 년도의 아직 오지않은 월 - button태그에 neighbor-month 클래스 추가 */
.bottom-sheet-modal .con-box .month-box button.neighbor-month {
  color: #bbb;
}
.bottom-sheet-modal .con-box .to-modal-inp {
  gap: 0.8rem;
}
.bottom-sheet-modal .con-box .to-modal-inp input {
  width: 100%;
  border-bottom: 0.1rem solid #ccc;
  height: 4rem;
}
.bottom-sheet-modal .con-box .to-modal-inp .ico-calendar {
  position: absolute;
  top: 1rem;
  right: 0;
  width: 2rem;
  height: 2rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}
.bottom-sheet-modal .mod-list-box {
  margin: 0.5rem 0 1rem;
}
.bottom-sheet-modal .mod-list-box button {
  width: 100%;
  padding: 1.8rem 2rem;
  font-size: 1.7rem;
  color: #333;
  text-align: left;
}
.bottom-sheet-modal.filter-modal .box .con-box {
  max-height: calc(100vh - 12rem);
  overflow-y: scroll;
}
.bottom-sheet-modal .filter-box {
  margin-bottom: 2.8rem;
}
.bottom-sheet-modal .filter-box .btn-box {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1.6rem;
}
.bottom-sheet-modal .filter-box .btn-box button {
  width: calc((100% - 2rem) / 3);
  height: 4.5rem;
  border-radius: 1.2rem;
  background-color: #f6f6f6;
  font-weight: 500;
  font-size: 1.5rem;
  color: #333;
}
.bottom-sheet-modal .filter-box .btn-box button.active {
  background-color: #dbf4ff;
  font-weight: 600;
}
.bottom-sheet-modal .filter-box .btn-box button.type2 {
  width: calc((100% - 1rem) / 2);
}
.bottom-sheet-modal .con-box .file-btn-box {
  width: 100%;
}
.bottom-sheet-modal .con-box .file-btn-box label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc((100% - 1rem) / 2);
  height: 4.5rem;
  border-radius: 1.2rem;
  background-color: #f6f6f6;
  font-weight: 500;
  color: #00b1d8;
}

.bottom-sheet-modal .button-box {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-top: 1rem;
  padding: 2rem;
  background-color: #fff;
}
.bottom-sheet-modal .button-box button {
  width: 100%;
  height: 5rem;
  border-radius: 0.8rem;
  background-color: #f6f6f6;
  font-weight: 500;
  color: #00b1d8;
}
.bottom-sheet-modal .button-box.type2 button {
  width: calc((100% - 1rem) / 2);
}

/* terms */
.alert-modal.terms .box {
  max-width: 33.4rem;
  padding: 0;
}
.alert-modal.terms .tit-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem;
  border-bottom: 0.1rem solid #444;
}
.alert-modal.terms .tit-box h2 {
  font-weight: 600;
  font-size: 1.5rem;
}
.alert-modal.terms .desc-box {
  height: 37rem;
  overflow-y: scroll;
  padding: 2rem 2rem 0 2rem;
}
.alert-modal.terms .desc-box p {
  font-size: 1.5rem;
  color: #333;
  line-height: 1.5;
}
.alert-modal.terms .button-box {
  padding: 2rem;
  background-color: #fff;
  border-radius: 0 0 1.2rem 1.2rem;
}

/* search-box */
.search-box-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  width: 100%;
  height: 100vh;
  background-color: #fff;
}
.search-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.8rem;
}
.search-box .flex-box {
  gap: 0.8rem;
  width: calc(100% - 7.5rem);
  height: 4.2rem;
  padding-inline: 1.2rem;
  border: 0.1rem solid #777;
  border-radius: 0.6rem;
  background-color: #fff;
}
.search-box input {
  width: calc(100% - 2.8rem);
  background-color: #fff;
  font-weight: 400;
  color: #222;
}
.search-box .remove-btn {
  display: block;
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) repeat center /
    contain;
}
.search-box .remove-btn.hidden {
  display: none;
}
.search-box .sch-btn-box {
  display: flex;
  align-items: center;
  gap: 0.8em;
}
.search-box .sch-btn-box .back-btn {
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center /
    contain;
}
.search-box .sch-btn-box .cancel-btn {
  font-size: 1.5rem;
}

/* privacy */
.privacy-box {
  padding: 2.8rem 0.4rem 8rem;
}
.privacy-box p {
  font-size: 1.5rem;
  color: #5f5f5f;
  line-height: 1.6;
  white-space: pre-wrap;
}

/* f-info */
.f-info {
  margin-top: 10rem;
  line-height: 1.48;
  font-size: 1.5rem;
  color: #727272;
}
.menu .f-info {
  margin-top: 2.8rem;
}

/* splash */
.splash-wrap {
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_47___}) no-repeat center /
    cover;
  z-index: 999;
}
.splash-wrap h1 {
  font-weight: 400;
  font-size: 3rem;
  color: #fff;
}
.splash-wrap .splash-tit {
  display: block;
  margin-top: 1.4rem;
  width: 13.6rem;
  height: 4.4rem;
}
.splash-wrap .circle-box {
  position: relative;
  width: 4.4rem;
  height: 4.4rem;
}
.splash-wrap .circle-box .circle {
  position: absolute;
  display: block;
  background-color: #dbf4ff;
  border-radius: 50%;
}
.splash-wrap .circle-box .circle.c1 {
  top: 0;
  left: 0;
  width: 2.4rem;
  height: 2.4rem;
  animation: cross1 0.7s ease-in-out 0.7s forwards;
}
.splash-wrap .circle-box .circle.c2 {
  bottom: 0;
  right: 0;
  width: 3.8rem;
  height: 3.8rem;
  opacity: 0.3;
  animation: cross2 0.7s ease-in-out 0.7s forwards;
}
@keyframes cross1 {
  0% {
    top: 0;
    left: 0;
  }
  100% {
    top: 2rem;
    left: 2rem;
  }
}
@keyframes cross2 {
  0% {
    bottom: 0;
    right: 0;
  }
  100% {
    bottom: 0.6rem;
    right: 0.6rem;
  }
}

/* swiper - detail-img-box */
.detail-img-box .swiper-slide {
  width: 100% !important;
  height: 22.5rem !important;
  border: 0.1rem solid #ddd;
  border-radius: 1.2rem !important;
  background-color: #eee;
}
.detail-img-box .swiper-slide img {
  width: 100% !important;
  height: 100% !important;
  border-radius: 1.2rem !important;
  object-fit: cover;
}
.detail-img-box .swiper-pagination {
  bottom: 1.4rem !important;
}
.detail-img-box .swiper-pagination-bullet {
  width: 1rem !important;
  height: 1rem !important;
  background-color: #ddd !important;
  opacity: 1 !important;
}
.detail-img-box .swiper-pagination-bullet-active {
  width: 1rem !important;
  height: 1rem !important;
  background-color: #000 !important;
  opacity: 1 !important;
}

/* swiper image-modal */
.image-modal .swiper-slide {
  width: 100%;
  min-height: 2rem;
  color: #fff;
  max-height: calc(100vh - 15rem);
}
.image-modal .swiper-slide img {
  display: block;
  width: 100%;
  height: auto;
}
.image-modal .swiper-pagination {
  display: none;
}

/* media query */
@media (max-width: 350px) {
  .user-info .info-box .info {
    flex-wrap: wrap;
    gap: 1rem;
  }
  .user-info .info-box .info .desc {
    width: 100%;
  }
}

/* react-calendar */
.bottom-sheet-modal.calendar .box.type2 {
  height: 48rem;
}
.react-calendar {
  width: 100% !important;
  position: relative;
  border: 0 !important;
  font-family: "ptd-v" !important;
}
.react-calendar__navigation {
  display: block !important;
  height: 2.8rem;
  margin-bottom: 1rem !important;
}
.react-calendar__navigation__label {
  position: absolute;
  top: 1.4rem;
  left: 1rem;
  font-weight: 500;
  font-size: 1.7rem;
  color: #333;
}
.react-calendar__navigation__arrow {
  position: absolute;
  top: 1.4rem;
}
.react-calendar__navigation__prev2-button,
.react-calendar__navigation__next2-button {
  display: none;
}
.react-calendar__navigation__prev-button {
  text-indent: -9999px;
  overflow: hidden;
  min-width: unset !important;
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_48___}) no-repeat center /
    contain !important;
  right: 5rem !important;
}
.react-calendar__navigation__next-button {
  text-indent: -9999px;
  overflow: hidden;
  min-width: unset !important;
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_49___}) no-repeat center /
    contain !important;
  right: 1rem !important;
}
.react-calendar__navigation__next-button {
  right: 0;
}
.react-calendar__month-view__weekdays__weekday abbr {
  font-weight: 400;
  font-size: 1.4rem;
  color: #9f9f9f !important;
  text-decoration: none;
}
.react-calendar__tile {
  background-color: transparent !important;
}
.react-calendar__tile abbr {
  font-size: 1.4rem !important;
  color: #000 !important;
}
.react-calendar__tile--active {
  border-radius: 0.9rem !important;
  background-color: #dbf4ff !important;
}
.react-calendar__tile--active abbr {
  font-weight: 500 !important;
  color: #00b1d8 !important;
}
.react-calendar__month-view__days__day--neighboringMonth {
  opacity: 0.3;
}
.react-calendar__year-view__months__month {
  padding-block: 1.8rem !important;
}
.react-calendar__year-view__months__month abbr {
  font-size: 1.6rem !important;
}
.react-calendar__tile--hasActive {
  padding-block: 1.8rem !important;
  border-radius: 0.9rem;
  background-color: #dbf4ff !important;
  font-weight: 500 !important;
  font-size: 1.6rem !important;
  color: #00b1d8 !important;
}
.react-calendar__tile--hasActive abbr {
  font-weight: 500 !important;
  font-size: 1.6rem !important;
  color: #00b1d8 !important;
}
.react-calendar__decade-view__years__year {
  padding-block: 1.8rem !important;
  font-size: 1.5rem !important;
}
.react-calendar__century-view__decades__decade {
  padding-block: 1.2rem !important;
  font-size: 1.5rem !important;
  color: #5d5d5d;
  word-break: keep-all !important;
}
.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: transparent !important;
}

/* 
  [말줄임 - 한줄]
  width: ;
  overflow: hidden; 
  text-overflow: ellipsis;
  white-space: nowrap;

  [말줄임 - 여러줄]
  width: ;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
*/
`, "",{"version":3,"sources":["webpack://./src/assets/css/component.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ;WACS;AACX;;AAEA,QAAQ;AACR;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA,cAAc;AACd;;;;GAIG;;AAEH,WAAW;AACX;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;AACA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iEAAiE;AACnE;AACA;EACE,mDAAmD;EACnD,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;;AAEA,aAAa;AACb,WAAW;AACX;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,aAAa;AACf,EAAE,8EAA8E;AAChF;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA,sBAAsB;AACtB;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,6CAA6C;EAC7C,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,cAAc;EACd,yDAA+D;AACjE;AACA,wBAAwB;AACxB;EACE,cAAc;AAChB;AACA;EACE,yDAAkE;AACpE;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;AACA;;;;;GAKG;;AAEH,eAAe;AACf;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,wCAAwC;AAC1C;AACA;;;GAGG;AACH;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,cAAc;EACd;WACS;AACX;AACA;EACE,aAAa;EACb,cAAc;EACd;WACS;AACX;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB;;;;;GAKC;EACD,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;oBACkB;AACpB;AACA;EACE;oBACkB;AACpB;AACA;EACE;oBACkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,cAAc;AACd,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,0DAA+D;AACjE;AACA;EACE,0DAAkE;AACpE;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,wBAAwB;AAC1B;AACA,YAAY;AACZ;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,cAAc;EACd,0DAAiE;AACnE;AACA;EACE,0DAAoE;AACtE;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,4BAA4B;;AAE5B,mBAAmB;AACnB,eAAe;AACf;EACE,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,gCAAgC;EAChC;qBACmB;EACnB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,cAAc;EACd,eAAe;EACf,6CAA6C;AAC/C;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA,mBAAmB;AACnB,qBAAqB;AACrB;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,0DAAsE;AACxE;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sCAAsC;EACtC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;EACd;WACS;AACX;;AAEA,iBAAiB;AACjB,eAAe;AACf;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,kDAAkD;AACpD;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;EAC5C,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,0DAAgE;AAClE;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB,eAAe;AACf;EACE,iBAAiB;AACnB;AACA;EACE,oCAAoC;AACtC;AACA,aAAa;AACb;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,cAAc;EACd,cAAc;EACd;oBACkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAAiE;AACnE;AACA;EACE,WAAW;EACX,uBAAkB;EAAlB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,cAAc;EACd,0DAA8D;AAChE;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB,wCAAwC;AACxC;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,4BAA4B;EAC5B,cAAc;AAChB;AACA;;EAEE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;EACb,kDAAkD;AACpD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iCAAiC;EACjC,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb;4BAC0B;EAC1B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB;WACS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ;WACS;AACX;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,MAAM;EACR;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;EAEE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ;qCACmC;AACrC;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE;iBACe;AACjB;AACA;EACE;8BAC4B;AAC9B;AACA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,6CAA6C;EAC7C,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,0DAA4D;AAC9D;AACA;EACE,0DAA+D;AACjE;AACA;EACE,0DAA+D;AACjE;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;;EAEjB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;;;;;;GAQG;AACH;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,cAAc;EACd,0DAA8D;AAChE;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;EACZ,0DAAoE;AACtE;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,0DAA8D;AAChE;AACA;EACE,0DAA8D;AAChE;AACA;EACE,aAAa;EACb,cAAc;EACd;WACS;AACX;AACA;EACE,0DAAqE;AACvE;AACA;EACE,0DAAiE;AACnE;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,cAAc;EACd,0DAAgE;AAClE;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;;EAEE,oBAAoB;AACtB;AACA;;EAEE,aAAa;EACb,oDAAoD;EACpD,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA,kBAAkB;AAClB;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,cAAc;EACd,0DAAoE;AACtE;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;AACA,QAAQ;AACR;;;;;iCAKiC;AACjC;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ;WACS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iDAAiD;AACnD;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,6CAA6C;EAC7C,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,cAAc;EACd,0DAAkE;AACpE;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iDAAiD;AACnD;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,cAAc;AACd;;;GAGG;AACH;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,cAAc;EACd,0DAA+D;AACjE;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB;wBACsB;AACxB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,cAAc;EACd,gCAAgC;EAChC,oCAAoC;EACpC,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,aAAa;EACb,cAAc;EACd,0DAAgE;AAClE;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;EACd,0DAA+D;AACjE;AACA;EACE,0DAAmE;AACrE;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,oDAAoD;AACtD;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;;EAEE,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,oBAAoB;EACpB,oDAAoD;AACtD;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB;uBACqB;EACrB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,0DAAgE;AAClE;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;;EAEhC,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;EACZ;WACS;AACX;AACA;EACE,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA,uDAAuD;AACvD;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,0DAAkE;AACpE;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ;WACS;AACX;AACA;EACE,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb;SACO;EACP,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,MAAM;EACN,OAAO;EACP,aAAa;EACb,cAAc;EACd,gDAAgD;AAClD;AACA;EACE,SAAS;EACT,QAAQ;EACR,aAAa;EACb,cAAc;EACd,YAAY;EACZ,gDAAgD;AAClD;AACA;EACE;IACE,MAAM;IACN,OAAO;EACT;EACA;IACE,SAAS;IACT,UAAU;EACZ;AACF;AACA;EACE;IACE,SAAS;IACT,QAAQ;EACV;EACA;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ;sBACoB;EACpB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ;sBACoB;EACpB,sBAAsB;AACxB;AACA;EACE,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,oCAAoC;EACpC,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,cAAc;EACd,+BAA+B;AACjC;AACA;;EAEE,wCAAwC;AAC1C;;AAEA;;;;;;;;;;;;;;CAcC","sourcesContent":["/* layout */\n.wrapper {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n}\n.content {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: calc(100vh - 4rem);\n  margin-top: 4rem;\n  padding: 2rem;\n  padding-bottom: 12rem;\n  align-self: flex-end;\n}\n\n/* header */\nheader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 4rem;\n  padding: 0 2rem;\n  background-color: #fff;\n  z-index: 99;\n}\nheader.right {\n  justify-content: flex-end;\n}\nheader h1 {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-weight: 600;\n  font-size: 1.6rem;\n}\nheader .h-btn-box {\n  display: flex;\n  align-items: center;\n  gap: 0.8em;\n}\nheader .h-btn-box .back-btn {\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_back.svg\") no-repeat center /\n    contain;\n}\nheader .h-btn-box .setting-btn {\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_setting.svg\") no-repeat center /\n    contain;\n}\nheader .h-btn-box .home-btn {\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_home.svg\") no-repeat center /\n    contain;\n}\nheader .h-btn-box .menu-btn {\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_menu.svg\") no-repeat center /\n    contain;\n}\nheader .h-btn-box .close-btn {\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_close.svg\") no-repeat center /\n    contain;\n}\n\n/* tab */\n.find .tab {\n  width: 100%;\n  padding: 0.5rem;\n  border-radius: 1.2rem;\n  background-color: #f0f0f0;\n}\n.find .tab .tab-button {\n  width: calc(100% / 2);\n  height: 4rem;\n  border-radius: 1.2rem;\n  font-size: 1.4rem;\n  color: #bbb;\n}\n.find .tab .tab-button.active {\n  background-color: #fff;\n  font-weight: 600;\n  color: #000;\n}\n\n/* title-box */\n/* .title-box h2 {\n  font-weight: 500;\n  font-size: 2rem;\n  line-height: 1.35;\n} */\n\n/* button */\n.fixed-button-box {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 2rem;\n  background-color: #fff;\n}\n.fixed-button-box p,\n.button-box p {\n  font-size: 1.5rem;\n  color: #333;\n}\n.fixed-button-box p button {\n  position: relative;\n  font-weight: 500;\n  color: #000;\n  text-decoration: underline;\n}\n.fixed-button-box p button::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -0.8rem;\n  width: 0.1rem;\n  height: 100%;\n  background-color: #444;\n}\n.button-box.type2 {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.btn1 {\n  width: 100%;\n  height: 5rem;\n  border-radius: 1.2rem;\n  font-weight: 600;\n}\n.button-box.type2 .btn1.narrow {\n  width: calc(((100% - 1rem) / 5) * 2);\n}\n.button-box.type2 .btn1.wide {\n  width: calc(((100% - 1rem) / 5) * 3);\n}\n.btn1.type2 {\n  border-radius: 2.5rem;\n}\n.btn1.type3 {\n  height: 4rem;\n  border-radius: 2rem;\n  font-weight: 500;\n  font-size: 1.5rem;\n}\n.btn1.main-color {\n  background-color: #00b1d8 !important;\n  color: #fff !important;\n}\n.btn1.sub-color {\n  background-color: #555 !important;\n  color: #fff !important;\n}\n.btn1.disabled {\n  background-color: #999 !important;\n  color: #ccc !important;\n}\n.btn1.cancel {\n  background-color: #ff7070 !important;\n  color: #fff !important;\n}\n\n/* round-box */\n.round-box {\n  border-radius: 1.2rem;\n  background-color: #f6f6f6;\n}\n.round-box.type2 {\n  background-color: #f3fbff;\n}\n.round-box.type3 {\n  background: linear-gradient(79deg, #1789fb 0.35%, #7fbcf8 98.51%);\n}\n.round-box.type4 {\n  box-shadow: 0 0 0.25rem 0 rgba(153, 153, 153, 0.25);\n  background-color: #fff;\n}\n.round-box.type5 {\n  background-color: #008ead;\n}\n\n/* form-box */\n/* tf-box */\n.tf-box-wrap {\n  margin-bottom: 2.8rem;\n}\n.tf-box label {\n  font-size: 1.4rem;\n  color: transparent;\n}\n.tf-box .line-box {\n  padding: 0.8rem 0;\n  border-bottom: 0.1rem solid #ccc;\n}\n.tf-box .line-box.type2 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n.tf-box .line-box .flex-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n.tf-box .line-box.type2 .flex-box {\n  width: calc(100% - 8.5rem);\n}\n.tf-box .line-box .tf {\n  width: calc(100% - 3rem);\n}\n.tf-box .line-box .card-num-box {\n  gap: 0.4rem;\n  width: calc(100% - 3rem);\n}\n.tf-box .line-box .card-num-box .tf {\n  width: 3.8rem;\n}\n.tf-box .line-box .tf[type=\"button\"] {\n  background-color: transparent;\n  font-size: 1.6rem;\n  color: #919191;\n  text-align: left;\n}\n.tf-box .line-box .remove-btn {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_remove.svg\") repeat center /\n    contain;\n}\n.tf-box .line-box .remove-btn.hidden {\n  display: none;\n} /* 기본 클래스 hidden을 갖고 있고, input에 값을 입력하기 시작하면 클래스 hidden을 지우고 remove-btn이 나타남 */\n.tf-box .line-box .btn-tf {\n  width: 7.5rem;\n  height: 2.5rem;\n  border: 0.1rem solid #ccc;\n  border-radius: 1rem;\n  background-color: #fff;\n  font-size: 1.3rem;\n  color: #999;\n}\n.tf-box .line-box .btn-tf.on {\n  border-color: #00b1d8;\n  color: #00b1d8;\n}\n/* input에 focus했을 경우 */\n.tf-box.focus label {\n  color: #999;\n}\n.tf-box.focus .line-box {\n  border-color: #000;\n}\n.tf-box.focus .line-box .tf[type=\"button\"] {\n  color: #000;\n}\n.tf-box-wrap .desc {\n  margin-top: 1rem;\n  font-weight: 500;\n  font-size: 1.3rem;\n  color: #777;\n}\n\n/* textarea-box */\n.textarea-box {\n  position: relative;\n}\n.textarea-box label {\n  display: block;\n  margin-bottom: 1rem;\n  font-weight: 500;\n  font-size: 1.5rem;\n}\n.textarea-box textarea {\n  width: 100%;\n  height: 22.5rem;\n  padding: 1.8rem;\n  border: 0.1rem solid rgba(204, 204, 204, 0.6);\n  border-radius: 1.2rem;\n  background-color: #fff;\n  color: #2f2f2f;\n  white-space: pre-wrap;\n}\n.textarea-box .total {\n  position: absolute;\n  bottom: 1.8rem;\n  right: 1.8rem;\n  font-size: 1.4rem;\n  color: #ccc;\n}\n.textarea-box .total.active {\n  color: #222;\n}\n\n/* validity-box */\n.validity-box-wrap {\n  display: flex;\n  align-items: center;\n  gap: 1.4rem;\n}\n.validity-box {\n  display: flex;\n  align-items: center;\n  gap: 1.6rem;\n}\n.validity-box li {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-weight: 500;\n  font-size: 1.3rem;\n  color: #999;\n}\n.validity-box .ico-check {\n  width: 1.8rem;\n  height: 1.8rem;\n  background-image: url(\"/src/assets/images/icon/icon_check.svg\");\n}\n/* validity-box 유효할 경우 */\n.validity-box.check li {\n  color: #00b1d8;\n}\n.validity-box.check .ico-check {\n  background-image: url(\"/src/assets/images/icon/icon_check_on.svg\");\n}\n\n/* list-box */\n.list-box .list {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.list-box .list:not(:last-of-type) {\n  margin-bottom: 1.6rem;\n}\n.list-box .list .tit {\n  color: #777;\n  word-break: keep-all;\n}\n.list-box .list .desc {\n  font-weight: 500;\n  color: #333;\n  text-align: right;\n  word-break: keep-all;\n}\n/* .list-box .tit {\n  width: 7.4rem;\n}\n.list-box .desc {\n  width: calc(100% - 7.4rem);\n} */\n\n/* filter-bar */\n.filter-bar {\n  position: sticky;\n  top: 4rem;\n  left: 0;\n  z-index: 90;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.8rem 2rem;\n  background-color: #f6f6f6;\n}\n.filter-bar .left-box .txt-box {\n  display: flex;\n  align-items: center;\n  gap: 1.6rem;\n}\n.filter-bar .left-box .txt-box li {\n  position: relative;\n  font-size: 1.4rem;\n  color: #777;\n  -webkit-tap-highlight-color: transparent;\n}\n/* .filter-bar .left-box .btn-tab button.active {\n  font-weight: 500;\n  color: #000;\n} */\n.filter-bar .left-box .txt-box li:not(:first-child):before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: -0.9rem;\n  width: 0.1rem;\n  height: 100%;\n  background-color: #b2b2b2;\n}\n.filter-bar .right-box {\n  gap: 1.6rem;\n}\n.filter-bar .ico-filter {\n  width: 2.5rem;\n  height: 2.5rem;\n  background: url(\"/src/assets/images/icon/icon_filter.png\") no-repeat center /\n    contain;\n}\n.filter-bar .ico-search {\n  width: 2.5rem;\n  height: 2.5rem;\n  background: url(\"/src/assets/images/icon/icon_search.svg\") no-repeat center /\n    contain;\n}\n\n/* login page */\n.login .title-box {\n  margin-bottom: 6rem;\n}\n.login .title-box h2 {\n  font-weight: 400;\n}\n.login .title-box h2 span {\n  display: inline-block;\n  position: relative;\n  margin-top: 0.6rem;\n  font-weight: 500;\n  font-size: 2.8rem;\n}\n.login .title-box h2 strong {\n  font-weight: 800;\n}\n.login .title-box h2 span::after {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  bottom: 1rem;\n  right: -2.2rem;\n  width: 1.2rem;\n  height: 1.2rem;\n  border-radius: 50%;\n  background: linear-gradient(\n    49deg,\n    #93d0de 22.26%,\n    #bbcef7 66.17%,\n    #ecd6d6 105.03%\n  );\n  opacity: 0.6;\n}\n\n/* social-login-box */\n.login .social-login-box .tit {\n  margin-bottom: 2rem;\n  color: #000;\n  text-align: center;\n}\n.login .social-login-box button {\n  width: 5rem;\n  height: 5rem;\n}\n.login .social-login-box button.naver {\n  background: url(\"/src/assets/images/icon/icon_round_naver.svg\") no-repeat\n    center / contain;\n}\n.login .social-login-box button.kakao {\n  background: url(\"/src/assets/images/icon/icon_round_kakao.svg\") no-repeat\n    center / contain;\n}\n.login .social-login-box button.apple {\n  background: url(\"/src/assets/images/icon/icon_round_apple.svg\") no-repeat\n    center / contain;\n}\n\n/* find result page */\n.find-result .round-box {\n  padding: 2.5rem;\n}\n.find-result .round-box strong {\n  display: block;\n  margin: 1rem 0 2rem;\n  font-weight: 500;\n  font-size: 2.3rem;\n}\n.find-result .round-box p.txt1 {\n  color: #777;\n}\n.find-result .round-box p.txt2 {\n  font-size: 1.5rem;\n  color: #919191;\n}\n\n/* indicator */\n.indicator {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 0.6rem;\n}\n.indicator li {\n  width: 1.6rem;\n  height: 1.6rem;\n  border-radius: 50%;\n  background-color: #f5f6f8;\n  color: #00b1d8;\n  font-weight: 500;\n  font-size: 1.2rem;\n}\n.indicator li.on {\n  background-color: #00b1d8;\n  color: #f5f6f8;\n}\n\n/* join page */\n/* social-join */\n.social-join button {\n  display: flex;\n  align-items: center;\n  gap: 1.6rem;\n  width: 100%;\n  height: 6rem;\n  padding: 0 1.6rem;\n  border-radius: 1.2rem;\n  font-weight: 500;\n}\n.social-join li:not(:last-child) {\n  margin-bottom: 1.2rem;\n}\n.social-join li:nth-child(1) button {\n  background-color: #fde500;\n}\n.social-join li:nth-child(2) button {\n  background-color: #03c759;\n  color: #fff;\n}\n.social-join li:nth-child(3) button {\n  background-color: #000;\n  color: #fff;\n}\n.social-join li:nth-child(4) button {\n  background-color: #f0f0f0;\n}\n\n/* agree-box */\n/* all-agree */\n.all-agree {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  height: 5rem;\n  border-radius: 1.2rem;\n  background-color: #f0f0f0;\n}\n.all-agree input {\n  position: absolute;\n  top: 50%;\n  left: 1.6rem;\n  transform: translateY(-50%);\n  width: 3rem;\n  height: 3rem;\n  background-image: url(\"/src/assets/images/icon/icon_agree.svg\");\n}\n.all-agree input:checked {\n  background-image: url(\"/src/assets/images/icon/icon_agree_on.svg\");\n}\n.all-agree span {\n  font-weight: 500;\n  color: #777;\n  letter-spacing: -0.08rem;\n}\n/* 체크했을 경우 */\n.all-agree.check {\n  background-color: #000;\n}\n.all-agree.check span {\n  color: #fff;\n}\n\n.agree-box .main-agree li {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  row-gap: 1rem;\n  -webkit-tap-highlight-color: transparent;\n}\n.agree-box .main-agree > li {\n  position: relative;\n  margin-bottom: 1.4rem;\n}\n.agree-box .main-agree button {\n  width: 100%;\n  padding: 0.4rem;\n  text-align: right;\n  z-index: 5;\n}\n.agree-box .main-agree > li.type2 {\n  height: 2.8rem;\n}\n.agree-box .main-agree > li.type2 button {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n  width: 3.4rem;\n  height: 2.8rem;\n}\n.agree-box .main-agree > li button.type2 {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 3.4rem;\n  height: 2.8rem;\n}\n\n.agree-box .main-agree > li > label {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  position: absolute;\n  top: 50%;\n  left: 0.4rem;\n  z-index: 10;\n  transform: translateY(-50%);\n  padding-block: 0.5rem;\n  padding-right: 1rem;\n}\n.agree-box .main-agree > li:nth-child(4) > label {\n  top: 1.4rem;\n}\n.agree-box .main-agree > li > label span:not(.main-color) {\n  font-size: 1.5rem;\n  color: #333;\n  letter-spacing: -0.08rem;\n}\n.agree-box .main-agree input {\n  width: 1.8rem;\n  height: 1.8rem;\n  background-image: url(\"/src/assets/images/icon/icon_agree_2.svg\");\n}\n.agree-box .main-agree input:checked {\n  background-image: url(\"/src/assets/images/icon/icon_agree_2_on.svg\");\n}\n.agree-box .main-agree ol {\n  padding-left: 2.8rem;\n  margin-top: 4rem;\n}\n.agree-box .main-agree ol label {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  /* padding: 0.6rem 0; */\n}\n.agree-box .main-agree ol input {\n  width: 1.6rem;\n  height: 1.6rem;\n}\n.agree-box .main-agree ol span:not(.main-color) {\n  font-size: 1.4rem;\n  color: #999;\n}\n\n/* phone verification page */\n\n/* room-join page */\n/* select-box */\n.select-box select {\n  width: 100%;\n  height: 4.4rem;\n  margin-bottom: 1.6rem;\n  border-bottom: 0.1rem solid #ccc;\n  background: url(\"/src/assets/images/icon/icon_down_arr.svg\") no-repeat top\n    1rem right / 2rem;\n  color: #919191;\n}\n\n/* detail-join page */\n.detail-join .form-box {\n  margin-bottom: 6.4rem;\n}\n.detail-join .tf-box-wrap {\n  margin-bottom: 1.4rem;\n}\n.detail-join .tf-box input {\n  font-size: 1.6rem;\n}\n\n/* join-complete page */\n.join-complete .content {\n  position: relative;\n}\n.join-complete .title-box h2 {\n  line-height: 1.4;\n}\n.join-complete .title-box h2 span {\n  font-size: 2.3rem;\n}\n.join-complete img.img-building {\n  position: fixed;\n  bottom: -15.8rem;\n  right: 3.7rem;\n  display: block;\n  width: 19.4rem;\n  height: 22.4rem;\n  animation: slide-up 0.55s ease 0.35s forwards;\n}\n@keyframes slide-up {\n  0% {\n    bottom: -15.8rem;\n  }\n  100% {\n    bottom: 5.4rem;\n  }\n}\n.join-complete .fixed-button-box {\n  padding-top: 0;\n}\n\n/* menu page */\n/* user-profile-box */\n.user-profile-box {\n  display: flex;\n  align-items: center;\n  gap: 1.8rem;\n}\n.user-profile-box img {\n  width: 5rem;\n  height: 5rem;\n  border-radius: 1.5rem;\n  background-color: #ededed;\n  object-fit: cover;\n  font-size: 1.3rem;\n  line-height: 1.2;\n  word-break: keep-all;\n}\n.user-profile-box button {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n}\n.user-profile-box button .txt {\n  font-weight: 500;\n  font-size: 2rem;\n}\n.user-profile-box.sns button .txt {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-weight: 400;\n  font-size: 1.8rem;\n}\n\n/* menu-box */\n.menu-box {\n  padding: 2rem 0;\n}\n.menu-box h4 {\n  margin-bottom: 1.2rem;\n}\n.menu-box ul .main-menu {\n  padding: 0.6rem 0;\n}\n.menu-box ul .main-menu button,\n.menu-box ul .main-menu .no-btn {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.menu-box ul .main-menu button span,\n.menu-box ul .main-menu .no-btn span {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  font-weight: normal;\n  font-size: 1.7rem;\n  color: #777;\n}\n.menu-box ul li ol {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1rem;\n  margin: 0.8rem 2rem 0 4rem;\n  padding: 0.6rem 0;\n}\n.menu-box ul li ol .sub-menu {\n  width: calc((100% - 1rem) / 2);\n}\n.menu-box ul li ol .sub-menu button {\n  display: block;\n  width: 100%;\n  height: 4.5rem;\n  border-radius: 1.5rem;\n  background-color: #ecf6f9;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.menu .round-box {\n  padding: 2.4rem 1.6rem;\n}\n.menu .round-box p.txt1 {\n  margin-bottom: 0.8rem;\n  color: #777;\n}\n.menu .round-box p.txt2 {\n  font-weight: 500;\n  font-size: 1.8rem;\n}\n.menu .round-box p.txt2 span {\n  font-weight: 400;\n  font-size: 1.5rem;\n  color: #222;\n}\n\n/* user info page */\n/* user-profile-box */\n.user-info .user-profile-box {\n  flex-direction: column;\n}\n.user-info .user-profile-box .img-box {\n  position: relative;\n}\n.user-info .user-profile-box img {\n  width: 10rem;\n  height: 10rem;\n  border-radius: 3.2rem;\n  background-color: #ededed;\n  object-fit: cover;\n  font-size: 1.3rem;\n  line-height: 1.2;\n  word-break: keep-all;\n}\n.user-info .user-profile-box .ico-round-camera {\n  position: absolute;\n  bottom: -0.3rem;\n  right: -0.5rem;\n  width: 3rem;\n  height: 3rem;\n  background-image: url(\"/src/assets/images/icon/icon_round_camera.svg\");\n}\n\n/* info-box */\n.user-info .info-box {\n  position: relative;\n  padding: 3rem 2rem;\n  border-top: 0.5rem solid #f6f6f6;\n}\n.user-info .exp {\n  margin: 0.5rem 0 4rem;\n  padding: 0 2.8rem 0 2rem;\n  /* border-top: 0.1rem solid #ebebeb; */\n  font-size: 1.4rem;\n  color: #b2b2b2;\n  line-height: 1.4;\n  word-break: keep-all;\n}\n.user-info .exp em {\n  font-style: normal;\n  color: #ff2424;\n}\n.user-info .info-box .info {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n}\n.user-info .info-box .info:not(:last-child) {\n  margin-bottom: 3rem;\n}\n.user-info .info-box .info .tit {\n  width: 9rem;\n  font-size: 1.5rem;\n  color: #999;\n}\n.user-info .info-box .info .desc {\n  display: flex;\n  justify-content: space-between;\n  align-self: flex-end;\n  align-items: center;\n  width: calc(100% - 11rem);\n}\n.user-info .info-box .info .desc p {\n  width: calc(100% - 4rem);\n  font-size: 1.7rem;\n}\n.user-info .info-box .info .desc .modification-btn {\n  width: 4rem;\n  height: 2.25rem;\n  background-color: #f6f6f6;\n  border-radius: 2.5rem;\n  font-size: 1.4rem;\n  color: #00b1d8;\n}\n.user-info .info-box .info .desc .alert-btn {\n  width: 2.2rem;\n  height: 2.2rem;\n  background: url(\"/src/assets/images/icon/icon_alert.svg\") no-repeat center /\n    contain;\n}\n\n/* setting page */\n/* switch-btn */\n.setting .switch-btn-wrap {\n  padding: 0.8rem 0;\n}\n.setting .switch-btn {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 0;\n}\n.setting .switch-btn span {\n  font-weight: 500;\n  color: #777;\n}\n.setting .switch-btn input {\n  position: relative;\n  width: 5rem;\n  height: 2.8rem;\n  border-radius: 2.8rem;\n  background-color: #ccc;\n  box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.25) inset;\n}\n.setting .switch-btn input::before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  top: 0.2rem;\n  left: 0.2rem;\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 50%;\n  background-color: #fff;\n  box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.25);\n  transition: left 0.4s ease;\n}\n.setting .switch-btn input:checked {\n  background-color: #00b1d8;\n}\n.setting .switch-btn input:checked::before {\n  left: calc(100% - 2.6rem);\n}\n\n/* bar-btn */\n.bar-btn {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n/* version-info-box */\n.setting .bar-btn {\n  height: 4rem;\n}\n\n.setting .version-info-box {\n  position: fixed;\n  bottom: 2.8rem;\n  left: 50%;\n  transform: translateX(-50%);\n  margin: auto;\n  text-align: center;\n}\n.setting .version-info-box span {\n  font-size: 1.5rem;\n}\n.setting .version-info-box p {\n  margin-top: 1.4rem;\n  font-size: 1.5rem;\n}\n\n/* withdrawal page */\n.withdrawal .terms-box {\n  height: 30rem;\n  padding: 2.4rem 1.6rem;\n}\n.withdrawal .terms-box .scroll-box {\n  height: 100%;\n  overflow-y: scroll;\n}\n.withdrawal .terms-box .desc-terms {\n  font-size: 1.5rem;\n  color: #777;\n}\n\n/* notice page */\n.notice .notice-box {\n  margin-bottom: 2.4rem;\n}\n.notice .notice-box .round-box {\n  padding: 1.6rem;\n}\n.notice .notice-box:first-of-type .round-box {\n  background-color: #f3fbff;\n}\n.notice .notice-box .round-box .txt-box {\n  height: 10.4rem;\n  overflow: hidden;\n}\n.notice .notice-box .round-box .txt-box.open {\n  height: auto;\n  overflow: auto;\n}\n.notice .notice-box .round-box .txt-box .tit {\n  margin-bottom: 1.4rem;\n  font-weight: 500;\n  font-size: 1.7rem;\n  color: #222;\n  line-height: 1.32;\n}\n.notice .notice-box .round-box .txt-box .desc {\n  font-size: 1.5rem;\n  color: #5e5e5e;\n  line-height: 1.52;\n  word-break: keep-all;\n  white-space: pre-wrap;\n}\n.notice .notice-box .round-box .down-btn {\n  margin-top: 1.4rem;\n  width: 100%;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_down_arr.svg\") no-repeat center /\n    contain;\n}\n.notice .notice-box .round-box .down-btn.active {\n  background-image: url(\"/src/assets/images/icon/icon_up_arr.svg\");\n}\n.notice .notice-box .date {\n  display: block;\n  margin-bottom: 1.6rem;\n  font-size: 1.5rem;\n  color: #555;\n}\n.notice .notice-box .time {\n  display: block;\n  margin-top: 0.8rem;\n  font-size: 1.4rem;\n  color: #222;\n  text-align: right;\n}\n\n/* payment method page */\n/* method-box */\n.payment-method .method-box .title-box h2 {\n  font-size: 1.8rem;\n}\n.payment-method .method-box button.cancel {\n  background-color: #ff7070 !important;\n}\n/* card-box */\n.method-box .card-box {\n  position: relative;\n  height: 15.4rem;\n  padding: 3rem 3rem 2.5rem;\n}\n.method-box .card-box::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: -6.6rem;\n  right: 0;\n  width: 10.4rem;\n  height: 6.6rem;\n  background: url(\"/src/assets/images/img/img_payment_card.png\") no-repeat\n    center / contain;\n}\n.method-box .no-card .txt-box {\n  text-align: center;\n}\n.method-box .no-card .txt-box p {\n  margin-top: 2rem;\n  font-size: 1.5rem;\n  color: #555;\n}\n.method-box .no-card .txt-box .ico-warning {\n  width: 4rem;\n  height: 4rem;\n  background-image: url(\"/src/assets/images/icon/icon_warning.svg\");\n}\n.method-box.no-regi .btn1 {\n  gap: 0.8rem;\n  width: fit-content;\n  padding: 0 2rem;\n  border: 0.1rem solid #999;\n  background-color: #fff;\n}\n.method-box.no-regi .btn1 .ico-plus {\n  width: 1.6rem;\n  height: 1.6rem;\n  background-image: url(\"/src/assets/images/icon/icon_plus.svg\");\n}\n\n.payment-method .round-box {\n  padding: 2.4rem 1.8rem;\n}\n\n/* registration complete page */\n.registration-complete .title-box {\n  text-align: center;\n}\n.registration-complete .title-box h2 {\n  font-size: 2.3rem;\n}\n\n/* claim history page */\n/* maintenance-cost-box & history-list */\n.maintenance-cost-box-wrap {\n  position: fixed;\n  top: 4rem;\n  left: 0;\n  z-index: 9;\n  width: 100%;\n  padding: 2rem;\n  background-color: #fff;\n}\n.maintenance-cost-box {\n  padding: 2rem;\n  background-color: #fff;\n  box-shadow: 0 0 0.4rem 0 rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n}\n.history-box {\n  margin-top: 21.4rem;\n}\n\n.maintenance-cost-box .state,\n.history-list .state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 6.5rem;\n  height: 2.6rem;\n  border: 0.1rem solid #000;\n  border-radius: 2.6rem;\n  font-weight: 500;\n  font-size: 1.3rem;\n}\n.maintenance-cost-box .state.red,\n.history-list .state.red {\n  border: 0.1rem solid #ff2424;\n  color: #ff2424;\n}\n.maintenance-cost-box .state.blue,\n.history-list .state.blue {\n  border: 0.1rem solid #242dff;\n  color: #242dff;\n}\n\n.maintenance-cost-box {\n  position: relative;\n  padding-bottom: 7.8rem;\n  transition: all 0.3s;\n}\n.maintenance-cost-box.hidden {\n  transition: all 0.5s;\n  padding-bottom: 2.5rem;\n}\n.maintenance-cost-box .cost {\n  font-size: 3.2rem;\n  text-align: right;\n}\n.maintenance-cost-box .cost strong {\n  font-weight: 700;\n}\n.maintenance-cost-box .due-date-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: absolute;\n  bottom: 2rem;\n  left: 2rem;\n  width: calc(100% - 4rem);\n  padding: 1.2rem 1.5rem;\n  border-radius: 1.2rem;\n  background-color: #00b1d8;\n  transition: all 1.7s;\n}\n.maintenance-cost-box .due-date-bar.hidden {\n  transition: all 0.2s;\n  opacity: 0;\n}\n.maintenance-cost-box .due-date-bar .tit {\n  font-size: 1.5rem;\n  color: #fff;\n}\n.maintenance-cost-box .due-date-bar .desc {\n  font-weight: 500;\n  font-size: 1.8rem;\n  color: #fff;\n}\n\n.history-list .list {\n  padding: 2rem 0;\n  position: relative;\n  cursor: pointer;\n}\n.history-list .list::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 4.6rem);\n  height: 0.1rem;\n  background-color: #ccc;\n}\n.history-list .list:last-of-type::after {\n  content: none;\n}\n.history-list .list .month {\n  color: #777;\n}\n.history-list .list .cost {\n  margin-top: 1.6rem;\n  font-size: 1.8rem;\n  color: #333;\n  text-align: right;\n}\n\n/* history detail page */\n.history-detail .content {\n  background-color: #f0f0f0;\n}\n.history-detail .maintenance-cost-box {\n  width: 100%;\n  height: 18rem;\n  box-shadow: 0 0 0.4rem 0 rgba(153, 153, 153, 0.25);\n}\n.history-detail .section1 .list-box {\n  padding: 2.4rem 0 1.4rem;\n}\n.history-detail .section1 .list-box.hidden {\n  height: 12rem;\n  overflow-y: hidden;\n}\n.history-detail .section3 .list-box .list {\n  margin-bottom: 0.5rem;\n  padding: 1.2rem 1.6rem;\n  border-radius: 1.2rem;\n  background-color: #f6f6f6;\n}\n.history-detail .section3 .list-box .list p {\n  font-weight: 400;\n  color: #555;\n}\n.history-detail .section3 .list-box .list p.tit {\n  font-size: 1.5rem;\n}\n\n/* detail-tab-box */\n.history-detail .detail-tab-box {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  /* height: calc(100vh - 28rem); */\n  border-radius: 1.2rem;\n  background-color: #fff;\n}\n.history-detail .detail-tab-box .tab {\n  padding: 0.5rem;\n}\n.history-detail .detail-tab-box .tab .tab-button {\n  width: calc(100% / 2);\n  height: 4rem;\n  border-radius: 1.2rem;\n  background-color: #fff;\n  font-size: 1.5rem;\n  color: #888;\n}\n.history-detail .detail-tab-box .tab .tab-button.active {\n  background-color: #dbf4ff;\n  font-weight: 500;\n  color: #000;\n}\n.history-detail .detail-tab-box .tab-content {\n  padding: 2rem;\n}\n.history-detail .detail-tab-box .section-box h2 {\n  font-size: 1.8rem;\n}\n.history-detail .chart-box .total-number {\n  gap: 4rem;\n}\n.history-detail .chart-box .total-number li {\n  font-size: 1.5rem;\n  color: #555;\n}\n.history-detail .chart-box .total-number li .number {\n  display: block;\n  margin-top: 1rem;\n  font-weight: 600;\n  font-size: 1.8rem;\n  color: #000;\n}\n.history-detail .detail-tab-box .button-box .btn1 {\n  border-radius: 0 0 1.2rem 1.2rem;\n}\n\n.history-detail2 .round-box {\n  padding: 2rem;\n  background: #f6f6f6 url(\"/src/assets/images/bg/bg_receipt.svg\") no-repeat top\n    29.8rem left 0 / contain;\n  box-shadow: none;\n}\n.history-detail2 .title-box h2 {\n  font-size: 1.7rem;\n  line-height: 1.6;\n}\n.history-detail2 .title-box h2 span {\n  display: block;\n  font-weight: 400;\n  font-size: 3.2rem;\n}\n.history-detail2 .list-box-wrap h2 {\n  font-size: 1.8rem;\n}\n.history-detail2 .list-box.type2 .list {\n  padding: 1.2rem 1.6rem;\n  margin-bottom: 0.8rem;\n  border-radius: 1.2rem;\n  background-color: #fff;\n}\n.history-detail2 .list-box.type2 .list .tit {\n  color: #000;\n}\n.history-detail2 .list-box.type2 .list .desc {\n  color: #555;\n}\n\n/* payment page */\n.payment .title-box h2 {\n  font-size: 1.7rem;\n  line-height: 1.6;\n}\n.payment .title-box h2 span {\n  display: block;\n  font-weight: 400;\n  font-size: 3.2rem;\n}\n\n.payment .round-box {\n  padding: 2rem;\n}\n.payment .list-box .tit {\n  width: 7.4rem;\n}\n.payment .list-box .desc {\n  width: calc(100% - 7.4rem);\n}\n.payment .bar-btn {\n  margin-top: 2.5rem;\n}\n.payment .bar-btn h3 {\n  font-size: 1.8rem;\n}\n\n/* payment detail page */\n.payment-detail .title-box .img-payment {\n  display: block;\n  width: 13rem;\n  height: 11.5rem;\n  margin: 0 auto 2rem;\n  background: url(\"/src/assets/images/img/img_payment.png\") no-repeat center /\n    contain;\n}\n.payment-detail .title-box h2 {\n  text-align: center;\n}\n.payment-detail .title-box h2 strong {\n  font-weight: 500;\n}\n\n/* card-box */\n.card-box {\n  position: relative;\n  height: 15.4rem;\n  padding: 3rem 3rem 2.5rem;\n}\n.card-box .card-info-box {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  height: 100%;\n}\n.card-box .card-info-box p {\n  font-weight: 500;\n}\n.card-box .card-info-box p.com {\n  align-self: flex-start;\n  font-size: 1.5rem;\n}\n.card-box .card-info-box p.num {\n  font-size: 1.8rem;\n}\n.card-box .card-info-box p.expi-date {\n  align-self: flex-end;\n}\n.card-box .card-info-box.wh-color p {\n  color: #fff;\n}\n.card-box .remove-btn {\n  position: absolute;\n  top: 1.6rem;\n  right: 1.6rem;\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_close.svg\") no-repeat center /\n    contain;\n}\n\n/* payment complete page */\n.payment-complete .title-box {\n  text-align: center;\n}\n.payment-complete .title-box .cost {\n  font-size: 2.3rem;\n  font-weight: 500;\n}\n\n.payment-complete .content .button-box {\n  text-align: center;\n}\n.payment-complete .content .btn1 {\n  width: fit-content;\n  padding: 0 3.6rem;\n}\n\n/* payment history */\n.payment-history .round-box {\n  height: 9rem;\n  margin: 2rem;\n  padding: 1rem;\n}\n.payment-history .hidden-box {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 5rem;\n}\n.payment-history .rolling-box {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  animation: rolling 6.4s infinite ease;\n}\n.payment-history .rolling-box p {\n  font-weight: 500;\n  font-size: 1.8rem;\n  color: #fff;\n  text-align: center;\n  line-height: 1.4;\n}\n@keyframes rolling {\n  7% {\n    top: 0;\n  }\n  50% {\n    top: -7.2rem;\n  }\n}\n\n.payment-history .history-list .list {\n  padding: 2rem;\n}\n.payment-history .history-list .list::after {\n  content: none;\n}\n.payment-history .history-list .list .txt1,\n.payment-history .history-list .list .txt2 {\n  font-size: 1.5rem;\n  color: #555;\n}\n.payment-history .history-list .list .txt3 {\n  font-size: 1.5rem;\n  color: #999;\n}\n.payment-history .history-list .list .cost {\n  margin-top: 0;\n}\n.payment-history .history-list .list .cost span {\n  font-weight: 500;\n}\n\n/* .payment history detail page */\n.history-detail-payment .round-box.box1 {\n  margin: 2rem;\n  padding: 2rem;\n}\n.history-detail-payment .round-box.box1 .txt2 {\n  font-size: 3.2rem;\n  text-align: right;\n}\n.history-detail-payment .list-box-wrap {\n  padding: 2rem;\n}\n.history-detail-payment .round-box.box1 .list-box .tit {\n  width: 7.4rem;\n}\n.history-detail-payment .round-box.box1 .list-box .desc {\n  width: calc(100% - 7.4rem);\n}\n.history-detail-payment hr {\n  width: 100%;\n  height: 0.1rem;\n  background-color: rgba(204, 204, 204, 0.2);\n}\n.history-detail-payment .round-box.box2 {\n  margin: 2rem;\n  margin-top: 1rem;\n  padding: 2rem;\n}\n.history-detail-payment .round-box.box2 p {\n  font-size: 1.5rem;\n  color: #777;\n  line-height: 1.5;\n  word-break: keep-all;\n}\n\n/* community main pages */\n/* category-box */\n.category-box {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 2rem;\n}\n.category-box li {\n  width: calc((100% - 4rem) / 3);\n}\n.category-box li button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.8rem;\n  width: 100%;\n  font-weight: 500;\n  font-size: 1.5rem;\n  word-break: keep-all;\n}\n\n/* banner */\n.banner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 1rem 0 3rem;\n  border-radius: 1.2rem;\n  width: 100%;\n  height: 8rem;\n  background: #dbf4ff url(\"/src/assets/images/img/img_banner.png\") no-repeat\n    bottom right 5rem / 9.5rem 5.9rem;\n}\n.banner p {\n  font-weight: 600;\n  font-size: 1.6rem;\n  line-height: 1.34;\n}\n\n/* ranking-list & today-list */\n.ranking-list-wrap {\n  background: url(\"/src/assets/images/img/img_grade.png\") no-repeat top right /\n    7.2rem 4.2rem;\n}\n.today-list-wrap {\n  background: url(\"/src/assets/images/img/img_clock.png\") no-repeat top 0.4rem\n    right 2rem / 4.2rem 4.2rem;\n}\n.ranking-list-wrap h2,\n.today-list-wrap h2 {\n  margin-bottom: 1.6rem;\n  font-weight: 600;\n  font-size: 1.8rem;\n}\n.ranking-list .list,\n.today-list .list-box {\n  padding: 1.6rem;\n  box-shadow: 0 0 0.25rem 0 rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n}\n.ranking-list .list:not(:last-child),\n.today-list .list-box:not(:last-child) {\n  margin-bottom: 1rem;\n}\n\n.ranking-list .list {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.8rem;\n  background-color: #fff;\n}\n.ranking-list .list:first-child {\n  background-color: #fdf4f2;\n  border: 0.1rem solid #fbca33;\n}\n.ranking-list .list .number-box {\n  width: 3.8rem;\n  height: 3.8rem;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.ranking-list .list:nth-child(1) .number-box {\n  background-image: url(\"/src/assets/images/img/img_best.png\");\n}\n.ranking-list .list:nth-child(2) .number-box {\n  background-image: url(\"/src/assets/images/img/img_number2.png\");\n}\n.ranking-list .list:nth-child(3) .number-box {\n  background-image: url(\"/src/assets/images/img/img_number3.png\");\n}\n.ranking-list .list .desc-box {\n  width: calc(100% - 12.2rem);\n}\n.ranking-list .list .desc-box .txt1 {\n  margin-bottom: 0.8rem;\n  font-weight: 500;\n  font-size: 1.5rem;\n  line-height: 1.34;\n\n  /* 밀즐임 - 두줄 이상일 경우 */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n.ranking-list .list:first-child .desc-box .txt1 {\n  color: #ff2424;\n}\n.ranking-list .list .desc-box .txt2 {\n  font-size: 1.3rem;\n  color: #555;\n}\n.ranking-list .list .desc-box .txt2 .category {\n  position: relative;\n  margin-right: 2rem;\n}\n/* .ranking-list .list .desc-box .txt2 .category::after {\n  content: \"\";\n  display: inline-block;\n  right: -1rem;\n  position: absolute;\n  width: 0.1rem;\n  height: 1.3rem;\n  background-color: #555;\n} */\n.ranking-list .list .view-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.4rem;\n  width: 5rem;\n}\n.ranking-list .list .view-box .ico-view {\n  width: 1.6rem;\n  height: 1.4rem;\n  background-image: url(\"/src/assets/images/icon/icon_view.svg\");\n}\n.ranking-list .list .view-box .num {\n  font-weight: 500;\n  font-size: 1.2rem;\n}\n\n.today-list .list .category-name {\n  display: inline-block;\n  margin-bottom: 1.2rem;\n  padding: 0.6rem 2rem;\n  border-radius: 0.7rem;\n  background-color: #ffdbfe;\n}\n.today-list .list .txt2 {\n  font-weight: 500;\n  font-size: 1.6rem;\n  color: #333;\n  line-height: 1.2;\n}\n\n/* community pages */\n/* no-content */\n.no-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2rem;\n  width: 100%;\n  height: 20rem;\n}\n.no-content.type2 {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  height: auto;\n}\n.no-content p {\n  font-size: 1.6rem;\n  color: #797979;\n}\n.ico-no-content {\n  width: 4.2rem;\n  height: 4rem;\n  background-image: url(\"/src/assets/images/icon/icon_no_content.svg\");\n}\n\n/* num-box */\n.num-box {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 1.6rem;\n}\n.num-box.type3 {\n  padding: 0 2rem;\n}\n.num-box li {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-weight: 500;\n  font-size: 1.2rem;\n  color: #555;\n}\n.num-box.type2 li {\n  font-size: 1.4rem;\n}\n.num-box li i {\n  width: 1.6rem;\n  height: 1.4rem;\n}\n.num-box.type2 li i {\n  width: 1.8rem;\n  height: 1.5rem;\n}\n.num-box .ico-view {\n  background-image: url(\"/src/assets/images/icon/icon_view.svg\");\n}\n.num-box .ico-like {\n  background-image: url(\"/src/assets/images/icon/icon_like.svg\");\n}\n.num-box button.ico-like {\n  width: 1.8rem;\n  height: 1.5rem;\n  background: url(\"/src/assets/images/icon/icon_like.svg\") no-repeat center /\n    contain;\n}\n.num-box button.ico-like.active {\n  background-image: url(\"/src/assets/images/icon/icon_like_active.svg\");\n}\n.num-box .ico-comment {\n  background-image: url(\"/src/assets/images/icon/icon_comment.svg\");\n}\n\n/* tab-community */\n.community .tab-community {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  align-items: center;\n  position: sticky;\n  top: 4rem;\n  left: 0;\n  width: 100%;\n  padding: 1.4rem;\n  background-color: #fff;\n  z-index: 9;\n}\n.community .tab-community button {\n  height: 4.4rem;\n  width: 8.2rem;\n  font-weight: 600;\n  font-size: 1.7rem;\n  color: #ccc;\n}\n.community .tab-community button.active {\n  color: #000;\n}\n\n/* notice-community */\n.ico-notice {\n  width: 2.5rem;\n  height: 2.5rem;\n  background-image: url(\"/src/assets/images/icon/icon_notice.svg\");\n}\n.notice-community {\n  border-top: 0.05rem solid #ddd;\n}\n.notice-community .item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1rem 2rem;\n  border-bottom: 0.05rem solid #ddd;\n  background-color: #fff;\n}\n\n/* community-list */\n.community-list,\n.inq-list {\n  padding-bottom: 2rem;\n}\n.community-list .list-box,\n.inq-list .list-box {\n  padding: 2rem;\n  border-bottom: 0.1rem solid rgba(204, 204, 204, 0.2);\n  cursor: pointer;\n}\n.inq-list .list-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.community-list .list-box:last-child,\n.inq-list .list-box:last-child {\n  border-bottom: 0;\n}\n.community-list .list-box .left-box,\n.inq-list .list-box .left-box {\n  width: calc(100% - 7rem);\n}\n.community-list .list-box .txt1,\n.inq-list .list-box .txt1 {\n  margin-bottom: 0.6rem;\n  font-weight: 500;\n  color: #333;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.community-list .list-box .txt2,\n.inq-list .list-box .txt2 {\n  font-size: 1.4rem;\n  color: #999;\n}\n\n.community-list2 .list-box {\n  display: flex;\n  align-items: center;\n  gap: 1.8rem;\n  cursor: pointer;\n}\n.community-main .today-list .list-box {\n  display: flex;\n  gap: 2rem;\n  padding: 1.6rem;\n}\n.community-list2 .list-box img,\n.community-main .today-list .list-box img {\n  display: block;\n  width: 10rem;\n  height: 10rem;\n  border-radius: 1.2rem;\n  background-color: #eee;\n  object-fit: cover;\n}\n.community-main .today-list .list-box img {\n  width: 7.8rem;\n  height: 7.8rem;\n}\n.community-list2 .list-box .desc-box {\n  width: calc(100% - 11.8rem);\n}\n.community-main .today-list .list-box .desc-box {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: calc(100% - 9.8rem);\n}\n.community-list2 .list-box .desc-box .txt-box .price {\n  margin-top: 1rem;\n  font-weight: 600;\n  font-size: 1.8rem;\n  color: #333;\n}\n.community-main .today-list .list-box .desc-box .txt-box .sort {\n  font-style: normal;\n  font-size: 1.4rem;\n}\n/* 커뮤니티 카테고리별 컬러 */\n.today-list .sort.sell {\n  color: #6155ef;\n}\n.today-list .sort.buy {\n  color: #e756f0;\n}\n.today-list .sort.knowledge {\n  color: #f55979;\n}\n.today-list .sort.building {\n  color: #f0bb56;\n}\n.today-list .sort.job {\n  color: #54c2e2;\n}\n.today-list .sort.free {\n  color: #8356ce;\n}\n\n.community-main .today-list .list-box .desc-box .txt-box .txt {\n  margin-top: 0.8rem;\n  font-weight: 500;\n  color: #333;\n  width: 100%;\n  /* 말줄임 */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.community-list2 .list-box .num-box {\n  margin-top: 1.6rem;\n}\n\n.community-list3 .list-box .txt1 {\n  margin-bottom: 2rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* writing-btn */\n.writing-btn {\n  position: fixed;\n  right: 2rem;\n  bottom: 2rem;\n  z-index: 9;\n}\n.writing-btn button {\n  gap: 0.5rem;\n  width: 8.5rem;\n  height: 4rem;\n  border-radius: 2rem;\n  background-color: #008ead;\n  font-weight: 600;\n  font-size: 1.5rem;\n  color: #fff;\n}\n.writing-btn .ico-plus-white {\n  width: 1.2rem;\n  height: 1.2rem;\n  background-image: url(\"/src/assets/images/icon/icon_plus_white.svg\");\n}\n\n/* detail */\n.user-box .user {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n.user-box .user img {\n  width: 3rem;\n  height: 3rem;\n  object-fit: cover;\n  border-radius: 0.9rem;\n}\n.user-box .user span {\n  font-weight: 700;\n  font-size: 1.5rem;\n}\n.user-box .txt1 {\n  margin-bottom: 1.2rem;\n  font-weight: 500;\n  line-height: 1.32;\n}\n/* 말줄임 */\n/* width: calc(100% - 3.2rem);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical; */\n.user-box .txt2 {\n  font-size: 1.4rem;\n  color: #999;\n}\n.edit-btn {\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_edit_btn.svg\") no-repeat center /\n    contain;\n}\n\n.detail-img-box {\n  padding: 2rem;\n}\n\n.detail-desc-box {\n  padding: 2rem;\n  border-top: 0.1rem solid rgba(204, 204, 204, 0.2);\n}\n.detail-desc-box .price {\n  display: block;\n  margin-bottom: 2rem;\n  font-weight: 600;\n  font-size: 1.8rem;\n  color: #333;\n}\n.detail-desc-box p {\n  font-size: 1.5rem;\n  color: #333;\n  line-height: 1.4;\n  white-space: pre-wrap;\n}\n\n.regit-box label {\n  display: block;\n  margin-bottom: 1rem;\n  font-weight: 500;\n  font-size: 1.5rem;\n}\n.regit-box textarea {\n  display: block;\n  width: 100%;\n  height: 7.8rem;\n  padding: 1.4rem 1.6rem;\n  border: 0.1rem solid rgba(204, 204, 204, 0.6);\n  border-bottom: 0;\n  border-radius: 1.2rem 1.2rem 0 0;\n  background-color: #fff;\n  color: #333;\n  line-height: 1.24;\n  white-space: pre-wrap;\n}\n.regit-box textarea::placeholder {\n  font-size: 1.5rem;\n  color: #ccc;\n}\n.regit-box .btn-box button {\n  width: 100%;\n  height: 4rem;\n  border-radius: 0 0 1.2rem 1.2rem;\n  background-color: #000;\n  font-size: 1.5rem;\n  color: #fff;\n}\n.regit-box .btn-box.type2 button {\n  border-radius: 0 0 0 1.2rem;\n  background-color: #555;\n}\n.regit-box .btn-box.type2 button.main {\n  border-radius: 0 0 1.2rem 0;\n  background-color: #00b1d8;\n}\n\n/* comment-box */\n.comment-box-wrap .comment-top-box {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1.6rem 2rem;\n}\n.comment-box-wrap .comment-top-box .ico-comment2 {\n  width: 1.4rem;\n  height: 1.4rem;\n  background-image: url(\"/src/assets/images/icon/icon_comment2.svg\");\n}\n.comment-box-wrap .comment-top-box span {\n  font-weight: 500;\n  font-size: 1.4rem;\n}\n.comment-box {\n  padding: 2rem;\n  border-top: 0.1rem solid rgba(204, 204, 204, 0.2);\n}\n.comment-box .txt1 {\n  font-size: 1.6rem;\n  color: #333;\n  line-height: 1.4;\n  white-space: pre-wrap;\n}\n.comment-box .reply-btn {\n  width: 5.5rem;\n  height: 3rem;\n  border-radius: 0.6rem;\n  background-color: #d9d9d9;\n  font-size: 1.4rem;\n}\n\n/* reply-box */\n/* .reply-box-wrap {\n  margin: 0 2rem;\n  padding: 2rem;\n} */\n.reply-box {\n  padding: 2rem;\n  background-color: #f3fbff;\n}\n.reply-box .flex-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n.reply-box .flex-box .left-box {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  width: calc(100% - 3rem);\n}\n.reply-box .flex-box .left-box .user-box {\n  width: calc(100% - 2.2rem);\n}\n.reply-box .icon-reply {\n  width: 1.2rem;\n  height: 1.8rem;\n  background-image: url(\"/src/assets/images/icon/icon_reply.svg\");\n}\n.reply-box .txt1 {\n  margin-bottom: 0;\n  font-size: 1.5rem;\n  white-space: pre-wrap;\n}\n\n/* attachment */\n.attachment {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  column-gap: 1rem;\n  row-gap: 2.8rem;\n}\n.attachment .file-btn {\n  width: 7rem;\n  height: 7rem;\n  border-radius: 0.8rem;\n  background: #333 url(\"/src/assets/images/icon/icon_camera.svg\") no-repeat top\n    1.7rem center / 2rem;\n}\n.attachment .file-btn .total {\n  margin-top: 2.2rem;\n  display: block;\n  font-size: 1.4rem;\n  color: #fff;\n  text-align: center;\n}\n.attachment .file-box {\n  position: relative;\n  width: 7rem;\n  height: 7rem;\n  /* padding: 0.4rem 0.2rem; */\n  border: 0.1rem solid #ddd;\n  border-radius: 0.8rem;\n  background-color: #eee;\n  font-size: 1.3rem;\n  color: #444;\n}\n.attachment .file-box img {\n  width: 100%;\n  height: 100%;\n  border-radius: 0.8rem;\n  object-fit: cover;\n}\n.attachment .file-box.represent span {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2.5rem;\n  border-radius: 0 0 0.8rem 0.8rem;\n  background-color: rgba(0, 0, 0, 0.6);\n  font-size: 1.4rem;\n  color: #fff;\n  text-align: center;\n  line-height: 2.5rem;\n}\n.attachment .file-box .remove-btn {\n  display: block;\n  position: absolute;\n  bottom: -2.2rem;\n  right: 0;\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_remove.svg\") repeat center /\n    contain;\n}\n.attachment .ico-camera {\n  width: 2.4rem;\n  height: 1.6rem;\n  background-image: url(\"/src/assets/images/icon/icon_camera.svg\");\n}\n\n/* inq-agree-box */\n.inq-agree-box h2 {\n  margin-bottom: 1.2rem;\n  font-size: 1.5rem;\n  color: #555;\n}\n.inq-agree-box .round-box {\n  padding: 1.5rem;\n  border: 0.1rem solid rgba(204, 204, 204, 0.6);\n  box-shadow: none;\n}\n.inq-agree-box .round-box p {\n  width: 100%;\n  height: 8.8rem;\n  overflow-y: scroll;\n  font-size: 1.4rem;\n  color: #777;\n  line-height: 1.4;\n}\n.inq-agree-box .inq-agree input {\n  width: 2.5rem;\n  height: 2.5rem;\n  background-image: url(\"/src/assets/images/icon/icon_agree.svg\");\n}\n.inq-agree-box .inq-agree input:checked {\n  background-image: url(\"/src/assets/images/icon/icon_agree_on2.svg\");\n}\n.inq-agree-box .inq-agree {\n  gap: 0.5rem;\n}\n.inq-agree-box .inq-agree label {\n  color: #777;\n}\n\n/* inq-tit-box */\n.inq-tit-box {\n  padding: 1.6rem 2rem;\n  border-bottom: 0.1rem solid rgba(204, 204, 204, 0.2);\n}\n.inq-tit-box .txt1 {\n  font-weight: 500;\n  color: #333;\n  line-height: 1.4;\n}\n.inq-tit-box .txt2,\n.inq-reply-box .txt2 {\n  font-size: 1.4rem;\n  color: #999;\n}\n.inq-tit-box .sort {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 1.4rem;\n  color: #d80000;\n}\n.inq-tit-box .sort.type2 {\n  display: inline-block;\n  padding: 0.6rem 2rem;\n  border-radius: 0.6rem;\n  background-color: #f6f6f6;\n}\n.inq-list .state,\n.inq-tit-box .state {\n  display: block;\n  padding: 0.6rem 0.8rem;\n  background-color: #f6f6f6;\n  border-radius: 4rem;\n  font-size: 1.4rem;\n  color: #999;\n}\n\n/* inq-desc-box */\n.inq-desc-box {\n  min-height: 15rem;\n  padding: 1.6rem 2rem;\n  border-bottom: 0.1rem solid rgba(204, 204, 204, 0.2);\n}\n.inq-desc-box img {\n  display: block;\n  width: 100%;\n  height: 20rem;\n  border: 0.1rem solid #eee;\n  border-radius: 1.2rem;\n  object-fit: cover;\n}\n.inq-desc-box p {\n  font-size: 1.5rem;\n  color: #777;\n  line-height: 1.4;\n  white-space: pre-wrap;\n}\n\n/* inq-reply-box */\n.inq-reply-box {\n  padding: 1.6rem 2rem;\n}\n.inq-reply-box .round-box {\n  min-height: 15rem;\n  padding: 1.6rem;\n}\n.inq-reply-box p {\n  font-size: 1.4rem;\n  color: #555;\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n/* office-info */\n.office-info img {\n  display: block;\n  width: 10rem;\n  height: 10rem;\n  margin: auto;\n  /* border-radius: 3rem; */\n  object-fit: contain;\n}\n.office-info .info-box .info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.office-info .info-box .info:not(:last-child) {\n  margin-bottom: 1.6rem;\n}\n.office-info .info-box .info p {\n  color: #333;\n}\n.office-info .info-box .info p.txt2 {\n  font-weight: 500;\n}\n\n/* to-modal-btn */\n.to-modal-btn {\n  width: 100%;\n  padding: 1.2rem 0;\n  border-bottom: 0.1rem solid #ccc;\n  text-align: left;\n  background: url(\"/src/assets/images/icon/icon_down_arr.svg\") no-repeat top\n    0.8rem right / 2rem;\n  color: #2f2f2f;\n  /* outline: none; */\n}\n.to-modal-btn.active {\n  background-image: url(\"/src/assets/images/icon/icon_up_arr.svg\");\n}\n.to-modal-btn2 {\n  gap: 0.5rem;\n  color: #444;\n}\n.to-modal-btn2 .ico-down-arr {\n  width: 1.8rem;\n  height: 1.8rem;\n}\n\n/* advertisement page */\n.advertisement h2 {\n  font-weight: 400;\n  font-size: 1.6rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.advertisement .ad-box:not(:last-child) {\n  margin-bottom: 3rem;\n}\n.advertisement .ad-box img {\n  display: block;\n  width: 100%;\n  height: 9rem;\n  border: 0.1rem solid #dfdfdf;\n  border-radius: 1.2rem;\n  background-color: #efefef;\n  object-fit: cover;\n  margin: 1.2rem 0;\n  font-size: 1.5rem;\n}\n.advertisement .ad-box .txt2 {\n  font-size: 1.4rem;\n  color: #999;\n}\n\n/* advertisement detail page */\n.advertisement-detail h2 {\n  font-weight: 400;\n  font-size: 1.6rem;\n  word-break: keep-all;\n}\n.advertisement-detail img {\n  display: block;\n  width: 100%;\n  height: calc((100vh / 3) * 2);\n  border-radius: 1.2rem;\n  background-color: #ddd;\n  object-fit: cover;\n  margin: 1.2rem 0;\n  font-size: 1.5rem;\n}\n.advertisement-detail .txt2 {\n  font-size: 1.4rem;\n  color: #999;\n}\n\n/* image-modal */\n.image-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #000;\n  z-index: 300;\n}\n.image-modal .top {\n  position: relative;\n  height: 4.8rem;\n  padding: 0 2rem;\n}\n.image-modal .top .indi {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  color: #fff;\n}\n.image-modal .top .back-btn {\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_w_back.svg\") no-repeat center /\n    contain;\n}\n.image-modal .image-box {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  width: 100%;\n}\n.image-modal .image-box img {\n  width: 100%;\n  object-fit: contain;\n}\n\n/* alert-modal */\n.alert-modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 300;\n}\n.alert-modal .box {\n  width: 100%;\n  max-width: 28rem;\n  padding: 2rem;\n  border-radius: 1.2rem;\n  background-color: #fff;\n}\n.alert-modal .top {\n  text-align: right;\n}\n.alert-modal .close-btn {\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_close.svg\") no-repeat center /\n    contain;\n}\n.alert-modal .icon-box {\n  margin: 1rem 0 2.5rem;\n  text-align: center;\n}\n.alert-modal .icon-box .ico-cas {\n  width: 8.4rem;\n  height: 6rem;\n  background: url(\"/src/assets/images/icon/icon_cas_modal.svg\") no-repeat center /\n    contain;\n}\n.alert-modal .desc {\n  width: 20rem;\n  margin: 1.8rem auto 2.8rem;\n}\n.alert-modal .desc p {\n  font-size: 1.5rem;\n  color: #777;\n  line-height: 1.6;\n  text-align: center;\n  word-break: keep-all;\n  white-space: pre-wrap;\n}\n.alert-modal .desc p.type2 {\n  color: #000;\n}\n.alert-modal .desc p .point {\n  color: #ff2424;\n}\n.alert-modal .button-box {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n}\n.alert-modal .btn1 {\n  height: 4.4rem;\n}\n\n/* bottom-modal */\n.bottom-sheet-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 250;\n}\n.bottom-sheet-modal .box {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  border-radius: 2rem 2rem 0 0;\n  background-color: #fff;\n}\n.bottom-sheet-modal.type1 .box {\n  height: 34rem;\n}\n.bottom-sheet-modal.type2 .box {\n  height: 22.8rem;\n}\n.bottom-sheet-modal.type3 .box {\n  height: 12.2rem;\n}\n.bottom-sheet-modal .tit-box {\n  padding: 2rem 2rem 1rem;\n}\n.bottom-sheet-modal .tit-box h2 {\n  font-weight: 600;\n}\n.bottom-sheet-modal .close-btn {\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_close.svg\") no-repeat center /\n    contain;\n}\n.bottom-sheet-modal .con-box {\n  height: calc(100% - 5.4rem);\n  overflow-y: scroll;\n}\n.bottom-sheet-modal .con-box.type2 {\n  padding-top: 1rem;\n  padding-inline: 2rem;\n  padding-bottom: 10rem;\n}\n.bottom-sheet-modal .con-box.type3 {\n  padding-bottom: 8.8rem;\n}\n.bottom-sheet-modal.type2 .con-box {\n  height: calc(100% - 5rem);\n}\n.bottom-sheet-modal .con-box .flex-box {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding-block: 1.4rem;\n}\n.bottom-sheet-modal .con-box .year-box {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem;\n  width: 8rem;\n}\n.bottom-sheet-modal .con-box .year-box button.prev {\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_up_arr.svg\") no-repeat center /\n    contain;\n}\n.bottom-sheet-modal .con-box .year-box button.next {\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_down_arr.svg\") no-repeat center /\n    contain;\n}\n.bottom-sheet-modal .con-box .year-box span {\n  display: block;\n  padding: 1rem;\n  font-weight: 500;\n  font-size: 2rem;\n  color: #333;\n}\n.bottom-sheet-modal .con-box .month-box {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  width: 16.2rem;\n}\n.bottom-sheet-modal .con-box .month-box button {\n  width: 5rem;\n  height: 5rem;\n  border-radius: 1.2rem;\n  background-color: #f6f6f6;\n  font-size: 1.6rem;\n  color: #777;\n}\n\n/* 해당 월 - button태그에 active 클래스 추가 */\n.bottom-sheet-modal .con-box .month-box button.active {\n  background-color: #dbf4ff;\n  color: #00b1d8;\n}\n/* 해당 년도의 아직 오지않은 월 - button태그에 neighbor-month 클래스 추가 */\n.bottom-sheet-modal .con-box .month-box button.neighbor-month {\n  color: #bbb;\n}\n.bottom-sheet-modal .con-box .to-modal-inp {\n  gap: 0.8rem;\n}\n.bottom-sheet-modal .con-box .to-modal-inp input {\n  width: 100%;\n  border-bottom: 0.1rem solid #ccc;\n  height: 4rem;\n}\n.bottom-sheet-modal .con-box .to-modal-inp .ico-calendar {\n  position: absolute;\n  top: 1rem;\n  right: 0;\n  width: 2rem;\n  height: 2rem;\n  background-image: url(\"/src/assets/images/icon/icon_calendar.svg\");\n}\n.bottom-sheet-modal .mod-list-box {\n  margin: 0.5rem 0 1rem;\n}\n.bottom-sheet-modal .mod-list-box button {\n  width: 100%;\n  padding: 1.8rem 2rem;\n  font-size: 1.7rem;\n  color: #333;\n  text-align: left;\n}\n.bottom-sheet-modal.filter-modal .box .con-box {\n  max-height: calc(100vh - 12rem);\n  overflow-y: scroll;\n}\n.bottom-sheet-modal .filter-box {\n  margin-bottom: 2.8rem;\n}\n.bottom-sheet-modal .filter-box .btn-box {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-top: 1.6rem;\n}\n.bottom-sheet-modal .filter-box .btn-box button {\n  width: calc((100% - 2rem) / 3);\n  height: 4.5rem;\n  border-radius: 1.2rem;\n  background-color: #f6f6f6;\n  font-weight: 500;\n  font-size: 1.5rem;\n  color: #333;\n}\n.bottom-sheet-modal .filter-box .btn-box button.active {\n  background-color: #dbf4ff;\n  font-weight: 600;\n}\n.bottom-sheet-modal .filter-box .btn-box button.type2 {\n  width: calc((100% - 1rem) / 2);\n}\n.bottom-sheet-modal .con-box .file-btn-box {\n  width: 100%;\n}\n.bottom-sheet-modal .con-box .file-btn-box label {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc((100% - 1rem) / 2);\n  height: 4.5rem;\n  border-radius: 1.2rem;\n  background-color: #f6f6f6;\n  font-weight: 500;\n  color: #00b1d8;\n}\n\n.bottom-sheet-modal .button-box {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  margin-top: 1rem;\n  padding: 2rem;\n  background-color: #fff;\n}\n.bottom-sheet-modal .button-box button {\n  width: 100%;\n  height: 5rem;\n  border-radius: 0.8rem;\n  background-color: #f6f6f6;\n  font-weight: 500;\n  color: #00b1d8;\n}\n.bottom-sheet-modal .button-box.type2 button {\n  width: calc((100% - 1rem) / 2);\n}\n\n/* terms */\n.alert-modal.terms .box {\n  max-width: 33.4rem;\n  padding: 0;\n}\n.alert-modal.terms .tit-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2rem;\n  border-bottom: 0.1rem solid #444;\n}\n.alert-modal.terms .tit-box h2 {\n  font-weight: 600;\n  font-size: 1.5rem;\n}\n.alert-modal.terms .desc-box {\n  height: 37rem;\n  overflow-y: scroll;\n  padding: 2rem 2rem 0 2rem;\n}\n.alert-modal.terms .desc-box p {\n  font-size: 1.5rem;\n  color: #333;\n  line-height: 1.5;\n}\n.alert-modal.terms .button-box {\n  padding: 2rem;\n  background-color: #fff;\n  border-radius: 0 0 1.2rem 1.2rem;\n}\n\n/* search-box */\n.search-box-wrap {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 200;\n  width: 100%;\n  height: 100vh;\n  background-color: #fff;\n}\n.search-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.8rem;\n}\n.search-box .flex-box {\n  gap: 0.8rem;\n  width: calc(100% - 7.5rem);\n  height: 4.2rem;\n  padding-inline: 1.2rem;\n  border: 0.1rem solid #777;\n  border-radius: 0.6rem;\n  background-color: #fff;\n}\n.search-box input {\n  width: calc(100% - 2.8rem);\n  background-color: #fff;\n  font-weight: 400;\n  color: #222;\n}\n.search-box .remove-btn {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_remove.svg\") repeat center /\n    contain;\n}\n.search-box .remove-btn.hidden {\n  display: none;\n}\n.search-box .sch-btn-box {\n  display: flex;\n  align-items: center;\n  gap: 0.8em;\n}\n.search-box .sch-btn-box .back-btn {\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_back.svg\") no-repeat center /\n    contain;\n}\n.search-box .sch-btn-box .cancel-btn {\n  font-size: 1.5rem;\n}\n\n/* privacy */\n.privacy-box {\n  padding: 2.8rem 0.4rem 8rem;\n}\n.privacy-box p {\n  font-size: 1.5rem;\n  color: #5f5f5f;\n  line-height: 1.6;\n  white-space: pre-wrap;\n}\n\n/* f-info */\n.f-info {\n  margin-top: 10rem;\n  line-height: 1.48;\n  font-size: 1.5rem;\n  color: #727272;\n}\n.menu .f-info {\n  margin-top: 2.8rem;\n}\n\n/* splash */\n.splash-wrap {\n  display: flex;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  padding: 2rem;\n  background: url(\"/src/assets/images/bg/bg_splash.png\") no-repeat center /\n    cover;\n  z-index: 999;\n}\n.splash-wrap h1 {\n  font-weight: 400;\n  font-size: 3rem;\n  color: #fff;\n}\n.splash-wrap .splash-tit {\n  display: block;\n  margin-top: 1.4rem;\n  width: 13.6rem;\n  height: 4.4rem;\n}\n.splash-wrap .circle-box {\n  position: relative;\n  width: 4.4rem;\n  height: 4.4rem;\n}\n.splash-wrap .circle-box .circle {\n  position: absolute;\n  display: block;\n  background-color: #dbf4ff;\n  border-radius: 50%;\n}\n.splash-wrap .circle-box .circle.c1 {\n  top: 0;\n  left: 0;\n  width: 2.4rem;\n  height: 2.4rem;\n  animation: cross1 0.7s ease-in-out 0.7s forwards;\n}\n.splash-wrap .circle-box .circle.c2 {\n  bottom: 0;\n  right: 0;\n  width: 3.8rem;\n  height: 3.8rem;\n  opacity: 0.3;\n  animation: cross2 0.7s ease-in-out 0.7s forwards;\n}\n@keyframes cross1 {\n  0% {\n    top: 0;\n    left: 0;\n  }\n  100% {\n    top: 2rem;\n    left: 2rem;\n  }\n}\n@keyframes cross2 {\n  0% {\n    bottom: 0;\n    right: 0;\n  }\n  100% {\n    bottom: 0.6rem;\n    right: 0.6rem;\n  }\n}\n\n/* swiper - detail-img-box */\n.detail-img-box .swiper-slide {\n  width: 100% !important;\n  height: 22.5rem !important;\n  border: 0.1rem solid #ddd;\n  border-radius: 1.2rem !important;\n  background-color: #eee;\n}\n.detail-img-box .swiper-slide img {\n  width: 100% !important;\n  height: 100% !important;\n  border-radius: 1.2rem !important;\n  object-fit: cover;\n}\n.detail-img-box .swiper-pagination {\n  bottom: 1.4rem !important;\n}\n.detail-img-box .swiper-pagination-bullet {\n  width: 1rem !important;\n  height: 1rem !important;\n  background-color: #ddd !important;\n  opacity: 1 !important;\n}\n.detail-img-box .swiper-pagination-bullet-active {\n  width: 1rem !important;\n  height: 1rem !important;\n  background-color: #000 !important;\n  opacity: 1 !important;\n}\n\n/* swiper image-modal */\n.image-modal .swiper-slide {\n  width: 100%;\n  min-height: 2rem;\n  color: #fff;\n  max-height: calc(100vh - 15rem);\n}\n.image-modal .swiper-slide img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n.image-modal .swiper-pagination {\n  display: none;\n}\n\n/* media query */\n@media (max-width: 350px) {\n  .user-info .info-box .info {\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n  .user-info .info-box .info .desc {\n    width: 100%;\n  }\n}\n\n/* react-calendar */\n.bottom-sheet-modal.calendar .box.type2 {\n  height: 48rem;\n}\n.react-calendar {\n  width: 100% !important;\n  position: relative;\n  border: 0 !important;\n  font-family: \"ptd-v\" !important;\n}\n.react-calendar__navigation {\n  display: block !important;\n  height: 2.8rem;\n  margin-bottom: 1rem !important;\n}\n.react-calendar__navigation__label {\n  position: absolute;\n  top: 1.4rem;\n  left: 1rem;\n  font-weight: 500;\n  font-size: 1.7rem;\n  color: #333;\n}\n.react-calendar__navigation__arrow {\n  position: absolute;\n  top: 1.4rem;\n}\n.react-calendar__navigation__prev2-button,\n.react-calendar__navigation__next2-button {\n  display: none;\n}\n.react-calendar__navigation__prev-button {\n  text-indent: -9999px;\n  overflow: hidden;\n  min-width: unset !important;\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_left_arr.svg\") no-repeat center /\n    contain !important;\n  right: 5rem !important;\n}\n.react-calendar__navigation__next-button {\n  text-indent: -9999px;\n  overflow: hidden;\n  min-width: unset !important;\n  width: 2rem;\n  height: 2rem;\n  background: url(\"/src/assets/images/icon/icon_right_arr.svg\") no-repeat center /\n    contain !important;\n  right: 1rem !important;\n}\n.react-calendar__navigation__next-button {\n  right: 0;\n}\n.react-calendar__month-view__weekdays__weekday abbr {\n  font-weight: 400;\n  font-size: 1.4rem;\n  color: #9f9f9f !important;\n  text-decoration: none;\n}\n.react-calendar__tile {\n  background-color: transparent !important;\n}\n.react-calendar__tile abbr {\n  font-size: 1.4rem !important;\n  color: #000 !important;\n}\n.react-calendar__tile--active {\n  border-radius: 0.9rem !important;\n  background-color: #dbf4ff !important;\n}\n.react-calendar__tile--active abbr {\n  font-weight: 500 !important;\n  color: #00b1d8 !important;\n}\n.react-calendar__month-view__days__day--neighboringMonth {\n  opacity: 0.3;\n}\n.react-calendar__year-view__months__month {\n  padding-block: 1.8rem !important;\n}\n.react-calendar__year-view__months__month abbr {\n  font-size: 1.6rem !important;\n}\n.react-calendar__tile--hasActive {\n  padding-block: 1.8rem !important;\n  border-radius: 0.9rem;\n  background-color: #dbf4ff !important;\n  font-weight: 500 !important;\n  font-size: 1.6rem !important;\n  color: #00b1d8 !important;\n}\n.react-calendar__tile--hasActive abbr {\n  font-weight: 500 !important;\n  font-size: 1.6rem !important;\n  color: #00b1d8 !important;\n}\n.react-calendar__decade-view__years__year {\n  padding-block: 1.8rem !important;\n  font-size: 1.5rem !important;\n}\n.react-calendar__century-view__decades__decade {\n  padding-block: 1.2rem !important;\n  font-size: 1.5rem !important;\n  color: #5d5d5d;\n  word-break: keep-all !important;\n}\n.react-calendar__navigation button:enabled:hover,\n.react-calendar__navigation button:enabled:focus {\n  background-color: transparent !important;\n}\n\n/* \n  [말줄임 - 한줄]\n  width: ;\n  overflow: hidden; \n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  [말줄임 - 여러줄]\n  width: ;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
